export default [
  {
    wordTranslated: "	abolish v. the tax was abolished in 1977	",
    czWord: "	zrušit   daň byla zrušena v roce 1977	",
  },
  { wordTranslated: "	abortion n. 	", czWord: "	potrat   	" },
  { wordTranslated: "	absence n. 	", czWord: "	nepřítomnost	" },
  { wordTranslated: "	absent adj. 	", czWord: "	nepřítomný   	" },
  { wordTranslated: "	absurd adj. 	", czWord: "	absurdní   	" },
  { wordTranslated: "	abundance n. 	", czWord: "	hojnost   	" },
  {
    wordTranslated: "	abuse n., v. a black eye and other signs of physical abuse	",
    czWord: "	zneužívání    monokl a další známky fyzického týrání	",
  },
  { wordTranslated: "	academy n. 	", czWord: "	akademie   	" },
  { wordTranslated: "	accelerate v. 	", czWord: "	zrychlit   	" },
  { wordTranslated: "	acceptance n. 	", czWord: "	přijetí   	" },
  {
    wordTranslated: "	accessible adj. the town is accessible by bus	",
    czWord: "	přístupný, dostupný 	",
  },
  {
    wordTranslated:
      "	accomplishment n.  the reduction of inflation was a remarkable accomplishment	",
    czWord: "	úspěch   snížení inflace bylo pozoruhodným úspěchem	",
  },
  {
    wordTranslated: "	accordance n. there is good accordance between these nations	",
    czWord: "	soulad   	",
  },
  {
    wordTranslated:
      "	accordingly adv. we have to discover what his plans are and act accordingly	",
    czWord: "	podle toho  musíme zjistit, jaké má plány, a podle toho jednat	",
  },
  {
    wordTranslated:
      "	accountability n. After all, the potential for prosecution is also an important part of accountability.	",
    czWord:
      "	odpovědnost   Potenciál k trestnímu stíhání je koneckonců také důležitou součástí odpovědnosti.	",
  },
  {
    wordTranslated:
      "	accountable adj. parents could be held accountable for their children's actions	",
    czWord: "	odpovědnost   rodiče by mohli nést odpovědnost za činy svých dětí	",
  },
  {
    wordTranslated: "	accumulate v. her goal was to accumulate a huge fortune	",
    czWord: "	hromadit   jejím cílem bylo nashromáždit obrovské jmění	",
  },
  {
    wordTranslated: "	accumulation n. the accumulation of wealth	",
    czWord: "	akumulace   hromadění bohatství	",
  },
  {
    wordTranslated: "	accusation n. there was accusation in Brian's voice	",
    czWord: "	obvinění   v Brianově hlase zaznělo obvinění	",
  },
  {
    wordTranslated:
      "	accused n. the accused was ordered to stand trial on a number of charges	",
    czWord:
      "	obviněný   obviněnému bylo nařízeno stanout před soudem v několika bodech obžaloby	",
  },
  { wordTranslated: "	acid adj. 	", czWord: "	kyselý   	" },
  {
    wordTranslated: "	acquisition n. the acquisition of management skills	",
    czWord: "	akvizice   získání manažerských dovedností	",
  },
  { wordTranslated: "	acre n. 	", czWord: "	akr   	" },
  { wordTranslated: "	activation n. 	", czWord: "	aktivace   	" },
  { wordTranslated: "	activist n. 	", czWord: "	aktivista   	" },
  { wordTranslated: "	acute adj. 	", czWord: "	akutní   	" },
  { wordTranslated: "	adaptation n. 	", czWord: "	adaptace   	" },
  { wordTranslated: "	adhere v. 	", czWord: "	dodržovat   	" },
  {
    wordTranslated:
      "	adjacent adj.  next to or adjoining something else. adjacent rooms	",
    czWord: "	sousední   vedle nebo vedle něčeho jiného.  sousední místnosti	",
  },
  {
    wordTranslated: "	adjustment n. I've made a few adjustments to my diet	",
    czWord: "	úprava   Udělal jsem pár úprav ve svém jídelníčku	",
  },
  { wordTranslated: "	administer v. 	", czWord: "	spravovat   	" },
  { wordTranslated: "	administrative adj. 	", czWord: "	administrativní   	" },
  { wordTranslated: "	administrator n. 	", czWord: "	správce   	" },
  {
    wordTranslated:
      "	admission n. an admission of guilt.  admission is $1 for adults and 50 cents for children	",
    czWord:
      "	Přiznání, vstupné   přiznání viny. vstupné je 1 $ pro dospělé a 50 centů pro děti	",
  },
  { wordTranslated: "	adolescent n. 	", czWord: "	dospívající   	" },
  { wordTranslated: "	adoption n. 	", czWord: "	adopce   	" },
  { wordTranslated: "	adverse adj. 	", czWord: "	nepříznivý   	" },
  { wordTranslated: "	advocate n., v. 	", czWord: "	advokát   	" },
  { wordTranslated: "	aesthetic adj. 	", czWord: "	estetický   	" },
  {
    wordTranslated: "	affection n. she felt affection for the wise old lady	",
    czWord: "	náklonnost   cítila k moudré staré paní náklonnost	",
  },
  {
    wordTranslated:
      "	aftermath n. During this year you will suffer the aftermath of acquired wrong habits.	",
    czWord:
      "	následky   Během tohoto roku budete trpět následky získaných nesprávných návyků.	",
  },
  { wordTranslated: "	aggression n. 	", czWord: "	agrese   	" },
  { wordTranslated: "	agricultural adj. 	", czWord: "	zemědělský   	" },
  {
    wordTranslated:
      "	aide n. an assistant to an important person, especially a political leader.	",
    czWord: "	pobočník   asistent významné osoby, zejména politického vůdce.	",
  },
  {
    wordTranslated: "	albeit conj. he was making progress, albeit rather slowly	",
    czWord: "	i když   dělal pokroky, i když dost pomalu	",
  },
  { wordTranslated: "	alert v., n., adj. 	", czWord: "	upozornění   	" },
  { wordTranslated: "	alien adj. 	", czWord: "	cizí   	" },
  { wordTranslated: "	align v. 	", czWord: "	zarovnat   	" },
  { wordTranslated: "	alignment n. 	", czWord: "	zarovnání   	" },
  { wordTranslated: "	alike adv., adj. 	", czWord: "	podobný  	" },
  {
    wordTranslated:
      "	allegation n. after leaving he made allegations of corruption against the company	",
    czWord: "	obvinění   po odchodu vznesl obvinění z korupce vůči společnosti	",
  },
  {
    wordTranslated: "	allege v. he alleged that he had been assaulted	",
    czWord: "	tvrdit   tvrdil, že byl napaden	",
  },
  {
    wordTranslated:
      "	allegedly adv. he was allegedly a leading participant in the coup attempt	",
    czWord: "	údajně  byl údajně předním účastníkem pokusu o převrat	",
  },
  { wordTranslated: "	alliance n. 	", czWord: "	aliance   	" },
  {
    wordTranslated: "	allocate v. the authorities allocated 50,000 places to refugees	",
    czWord: "	přidělit   úřady přidělily uprchlíkům 50 000 míst	",
  },
  {
    wordTranslated: "	allocation n. more efficient allocation of resources	",
    czWord: "	přidělení   efektivnější přidělení zdrojů	",
  },
  {
    wordTranslated:
      "	allowance n. give (someone) a sum of money regularly as an allowance.	",
    czWord:
      "	příspěvek   dávat (někomu) pravidelně peněžní částku jako příspěvek.	",
  },
  { wordTranslated: "	ally n. 	", czWord: "	spojenec   	" },
  { wordTranslated: "	aluminium n. 	", czWord: "	hliník   	" },
  { wordTranslated: "	amateur adj., n. 	", czWord: "	amatérský    	" },
  { wordTranslated: "	ambassador n. 	", czWord: "	velvyslanec   	" },
  {
    wordTranslated: "	amend v. did she amend her original will later on?	",
    czWord: "	upravit   pozměnila později svou původní závěť?	",
  },
  {
    wordTranslated: "	amendment n. an amendment to existing bail laws	",
    czWord: "	pozměňovací návrh   novela stávajících zákonů o kauci	",
  },
  {
    wordTranslated:
      "	amid prep. our dream home, set amid magnificent rolling countryside	",
    czWord:
      "	uprostřed přípravy. náš vysněný dům uprostřed nádherné zvlněné krajiny	",
  },
  { wordTranslated: "	analogy n. 	", czWord: "	analogie   	" },
  { wordTranslated: "	anchor n. 	", czWord: "	kotva   	" },
  { wordTranslated: "	angel n. 	", czWord: "	anděl   	" },
  { wordTranslated: "	anonymous adj. 	", czWord: "	anonymní   	" },
  { wordTranslated: "	apparatus n. 	", czWord: "	přístroj, zařízení   	" },
  { wordTranslated: "	appealing adj. 	", czWord: "	přitažlivý   	" },
  { wordTranslated: "	appetite n. 	", czWord: "	chuť k jídlu   	" },
  { wordTranslated: "	applaud v. 	", czWord: "	tleskat   	" },
  { wordTranslated: "	applicable adj. 	", czWord: "	použitelný   	" },
  {
    wordTranslated: "	appoint v. she has been appointed to the board	",
    czWord: "	jmenovat   byla jmenována do představenstva	",
  },
  {
    wordTranslated:
      "	appreciation n.  the bank's lack of appreciation of their problems	",
    czWord: "	ocenění   banky nedoceňují jejich problémy	",
  },
  {
    wordTranslated: "	arbitrary adj. his mealtimes were entirely arbitrary	",
    czWord: "	libovolný   jeho doby jídla byly zcela libovolné	",
  },
  { wordTranslated: "	architectural adj. 	", czWord: "	architektonický   	" },
  { wordTranslated: "	archive n. 	", czWord: "	archiv   	" },
  { wordTranslated: "	arena n. 	", czWord: "	aréna   	" },
  { wordTranslated: "	arguably adv. 	", czWord: "	pravděpodobně  	" },
  { wordTranslated: "	arm v. 	", czWord: "	paže   	" },
  { wordTranslated: "	array n. 	", czWord: "	pole   	" },
  { wordTranslated: "	articulate v. 	", czWord: "	artikulovat   	" },
  { wordTranslated: "	ash n. 	", czWord: "	popel   	" },
  { wordTranslated: "	aspiration n. 	", czWord: "	aspirace   	" },
  { wordTranslated: "	aspire v. 	", czWord: "	aspirovat   	" },
  { wordTranslated: "	assassination n. 	", czWord: "	atentát   	" },
  { wordTranslated: "	assault n., v. 	", czWord: "	útok    	" },
  { wordTranslated: "	assemble v. 	", czWord: "	sestavit   	" },
  { wordTranslated: "	assembly n. 	", czWord: "	montáž   	" },
  { wordTranslated: "	assert v. 	", czWord: "	tvrdit   	" },
  { wordTranslated: "	assertion n. 	", czWord: "	tvrzení   	" },
  { wordTranslated: "	assurance n. 	", czWord: "	ujištění   	" },
  { wordTranslated: "	asylum n. 	", czWord: "	azyl   	" },
  { wordTranslated: "	atrocity n. 	", czWord: "	zvěrstvo   	" },
  { wordTranslated: "	attain v. 	", czWord: "	dosáhnout   	" },
  { wordTranslated: "	attendance n. 	", czWord: "	návštěvnost   	" },
  { wordTranslated: "	attorney n. 	", czWord: "	advokát   	" },
  { wordTranslated: "	attribute v., n. 	", czWord: "	atribut    	" },
  { wordTranslated: "	audit n. 	", czWord: "	audit   	" },
  { wordTranslated: "	authentic adj. 	", czWord: "	autentický   	" },
  { wordTranslated: "	authorize v. 	", czWord: "	autorizovat   	" },
  { wordTranslated: "	auto n. 	", czWord: "	auto   	" },
  { wordTranslated: "	autonomy n. 	", czWord: "	autonomie   	" },
  { wordTranslated: "	availability n. 	", czWord: "	dostupnost   	" },
  { wordTranslated: "	await v. 	", czWord: "	čekat   	" },
  { wordTranslated: "	backdrop n. 	", czWord: "	pozadí   	" },
  { wordTranslated: "	backing n. 	", czWord: "	podpora   	" },
  { wordTranslated: "	backup n. 	", czWord: "	záloha   	" },
  { wordTranslated: "	bail n. 	", czWord: "	kauce   	" },
  { wordTranslated: "	ballot n. 	", czWord: "	hlasovací lístek   	" },
  { wordTranslated: "	banner n. 	", czWord: "	banner   	" },
  { wordTranslated: "	bare adj. 	", czWord: "	holý   	" },
  { wordTranslated: "	barrel n. 	", czWord: "	sud   	" },
  { wordTranslated: "	bass1 n. 	", czWord: "	bas1   	" },
  { wordTranslated: "	bat v. 	", czWord: "	netopýr   	" },
  { wordTranslated: "	battlefield n. 	", czWord: "	bojiště   	" },
  { wordTranslated: "	bay n. 	", czWord: "	zátoka   	" },
  { wordTranslated: "	beam n. 	", czWord: "	paprsek   	" },
  { wordTranslated: "	beast n. 	", czWord: "	šelma   	" },
  { wordTranslated: "	behalf n. 	", czWord: "	jménem   	" },
  { wordTranslated: "	beloved adj. 	", czWord: "	milovaný   	" },
  { wordTranslated: "	bench n. 	", czWord: "	lavice   	" },
  { wordTranslated: "	benchmark n. 	", czWord: "	benchmark   	" },
  { wordTranslated: "	beneath prep. 	", czWord: "	pod přípravou. 	" },
  { wordTranslated: "	beneficiary n. 	", czWord: "	příjemce   	" },
  { wordTranslated: "	betray v. 	", czWord: "	zradit   	" },
  { wordTranslated: "	bind v. 	", czWord: "	vázat   	" },
  { wordTranslated: "	biography n. 	", czWord: "	životopis   	" },
  { wordTranslated: "	bishop n. 	", czWord: "	biskup   	" },
  { wordTranslated: "	bizarre adj. 	", czWord: "	bizarní   	" },
  { wordTranslated: "	blade n. 	", czWord: "	čepel   	" },
  { wordTranslated: "	blast n., v. 	", czWord: "	výbuch    	" },
  { wordTranslated: "	bleed v. 	", czWord: "	krvácet   	" },
  { wordTranslated: "	blend v., n. 	", czWord: "	směs     	" },
  { wordTranslated: "	bless v. 	", czWord: "	požehnat   	" },
  { wordTranslated: "	blessing n. 	", czWord: "	požehnání   	" },
  { wordTranslated: "	boast v. 	", czWord: "	chlubit se   	" },
  { wordTranslated: "	bonus n. 	", czWord: "	bonus   	" },
  { wordTranslated: "	boom n. 	", czWord: "	bum   	" },
  { wordTranslated: "	bounce v. 	", czWord: "	odrazit   	" },
  { wordTranslated: "	boundary n. 	", czWord: "	hranice   	" },
  { wordTranslated: "	bow1 v., n. 	", czWord: "	luk1    	" },
  { wordTranslated: "	breach n., v. 	", czWord: "	porušení   	" },
  { wordTranslated: "	breakdown n. 	", czWord: "	členění   	" },
  { wordTranslated: "	breakthrough n. 	", czWord: "	průlom   	" },
  { wordTranslated: "	breed v., n. 	", czWord: "	plemeno    	" },
  { wordTranslated: "	broadband n. 	", czWord: "	širokopásmové připojení   	" },
  { wordTranslated: "	browser n. 	", czWord: "	prohlížeč   	" },
  { wordTranslated: "	brutal adj. 	", czWord: "	brutální   	" },
  { wordTranslated: "	buck n. 	", czWord: "	dolar   	" },
  { wordTranslated: "	buddy n. 	", czWord: "	kamarád   	" },
  { wordTranslated: "	buffer n. 	", czWord: "	nárazník   	" },
  { wordTranslated: "	bulk n. 	", czWord: "	hromadné   	" },
  { wordTranslated: "	burden n. 	", czWord: "	zátěž   	" },
  { wordTranslated: "	bureaucracy n. 	", czWord: "	byrokracie   	" },
  { wordTranslated: "	burial n. 	", czWord: "	pohřeb   	" },
  { wordTranslated: "	burst v. 	", czWord: "	prasknout   	" },
  { wordTranslated: "	cabinet n. 	", czWord: "	skříň   	" },
  { wordTranslated: "	calculation n. 	", czWord: "	výpočet   	" },
  { wordTranslated: "	canvas n. 	", czWord: "	plátno   	" },
  { wordTranslated: "	capability n. 	", czWord: "	schopnost   	" },
  { wordTranslated: "	capitalism n. 	", czWord: "	kapitalismus   	" },
  { wordTranslated: "	capitalist adj. 	", czWord: "	kapitalistický   	" },
  { wordTranslated: "	cargo n. 	", czWord: "	náklad   	" },
  { wordTranslated: "	carriage n. 	", czWord: "	kočár   	" },
  { wordTranslated: "	carve v. 	", czWord: "	vyřezávat   	" },
  { wordTranslated: "	casino n. 	", czWord: "	kasino   	" },
  { wordTranslated: "	casualty n. 	", czWord: "	oběť   	" },
  { wordTranslated: "	catalogue n. 	", czWord: "	katalog   	" },
  { wordTranslated: "	cater v. 	", czWord: "	obstarávat   	" },
  { wordTranslated: "	cattle n. 	", czWord: "	dobytek   	" },
  { wordTranslated: "	caution n. 	", czWord: "	pozor   	" },
  { wordTranslated: "	cautious adj. 	", czWord: "	opatrný   	" },
  { wordTranslated: "	cease v. 	", czWord: "	přestat   	" },
  { wordTranslated: "	cemetery n. 	", czWord: "	hřbitov   	" },
  { wordTranslated: "	chamber n. 	", czWord: "	komora   	" },
  { wordTranslated: "	chaos n. 	", czWord: "	chaos   	" },
  { wordTranslated: "	characterize v. 	", czWord: "	charakterizovat   	" },
  { wordTranslated: "	charm n. 	", czWord: "	kouzlo   	" },
  { wordTranslated: "	charter n. 	", czWord: "	charta   	" },
  { wordTranslated: "	chronic adj. 	", czWord: "	chronický   	" },
  { wordTranslated: "	chunk n. 	", czWord: "	kus   	" },
  { wordTranslated: "	circulate v. 	", czWord: "	obíhat   	" },
  { wordTranslated: "	circulation n. 	", czWord: "	oběh   	" },
  { wordTranslated: "	citizenship n. 	", czWord: "	občanství   	" },
  { wordTranslated: "	civic adj. 	", czWord: "	občanský   	" },
  { wordTranslated: "	civilian n., adj. 	", czWord: "	civilní    	" },
  { wordTranslated: "	clarity n. 	", czWord: "	jasnost  	" },
  { wordTranslated: "	clash n. 	", czWord: "	střet   	" },
  { wordTranslated: "	classification n. 	", czWord: "	klasifikace   	" },
  { wordTranslated: "	cling v. 	", czWord: "	držet se   	" },
  { wordTranslated: "	clinical adj. 	", czWord: "	klinický   	" },
  { wordTranslated: "	closure n. 	", czWord: "	uzavření   	" },
  { wordTranslated: "	cluster n. 	", czWord: "	shluk   	" },
  { wordTranslated: "	coalition n. 	", czWord: "	koalice   	" },
  { wordTranslated: "	coastal adj. 	", czWord: "	pobřežní   	" },
  { wordTranslated: "	cocktail n. 	", czWord: "	koktejl   	" },
  { wordTranslated: "	cognitive adj. 	", czWord: "	poznávací   	" },
  { wordTranslated: "	coincide v. 	", czWord: "	shodují se   	" },
  { wordTranslated: "	collaborate v. 	", czWord: "	spolupracovat   	" },
  { wordTranslated: "	collaboration n. 	", czWord: "	spolupráce   	" },
  { wordTranslated: "	collective adj. 	", czWord: "	kolektivní   	" },
  { wordTranslated: "	collision n. 	", czWord: "	kolize   	" },
  { wordTranslated: "	colonial adj. 	", czWord: "	koloniální   	" },
  { wordTranslated: "	columnist n. 	", czWord: "	fejetonista   	" },
  { wordTranslated: "	combat n., v. 	", czWord: "	boj    	" },
  { wordTranslated: "	commence v. 	", czWord: "	začít   	" },
  { wordTranslated: "	commentary n. 	", czWord: "	komentář   	" },
  { wordTranslated: "	commentator n. 	", czWord: "	komentátor   	" },
  { wordTranslated: "	commerce n. 	", czWord: "	obchod   	" },
  { wordTranslated: "	commissioner n. 	", czWord: "	komisař   	" },
  { wordTranslated: "	commodity n. 	", czWord: "	zboží   	" },
  { wordTranslated: "	communist adj. 	", czWord: "	komunistický   	" },
  { wordTranslated: "	companion n. 	", czWord: "	společník   	" },
  { wordTranslated: "	comparable adj. 	", czWord: "	srovnatelný   	" },
  { wordTranslated: "	compassion n. 	", czWord: "	soucit   	" },
  { wordTranslated: "	compel v. 	", czWord: "	přinutit   	" },
  { wordTranslated: "	compelling adj. 	", czWord: "	přesvědčivý   	" },
  { wordTranslated: "	compensate v. 	", czWord: "	kompenzovat   	" },
  { wordTranslated: "	compensation n. 	", czWord: "	kompenzace   	" },
  { wordTranslated: "	competence n. 	", czWord: "	kompetence   	" },
  { wordTranslated: "	competent adj. 	", czWord: "	kompetentní   	" },
  { wordTranslated: "	compile v. 	", czWord: "	sestavit   	" },
  { wordTranslated: "	complement v. 	", czWord: "	doplňovat   	" },
  { wordTranslated: "	complexity n. 	", czWord: "	složitost   	" },
  { wordTranslated: "	compliance n. 	", czWord: "	soulad   	" },
  { wordTranslated: "	complication n. 	", czWord: "	komplikace   	" },
  { wordTranslated: "	comply v. 	", czWord: "	vyhovět   	" },
  { wordTranslated: "	composition n. 	", czWord: "	složení   	" },
  { wordTranslated: "	compromise n., v. 	", czWord: "	kompromis    	" },
  { wordTranslated: "	compute v. 	", czWord: "	vypočítat   	" },
  { wordTranslated: "	conceal v. 	", czWord: "	skrýt   	" },
  { wordTranslated: "	concede v. 	", czWord: "	připustit   	" },
  { wordTranslated: "	conceive v. 	", czWord: "	otěhotnět   	" },
  { wordTranslated: "	conception n. 	", czWord: "	početí   	" },
  { wordTranslated: "	concession n. 	", czWord: "	koncese   	" },
  { wordTranslated: "	condemn v. 	", czWord: "	odsoudit   	" },
  { wordTranslated: "	confer v. 	", czWord: "	udělit   	" },
  { wordTranslated: "	confession n. 	", czWord: "	přiznání   	" },
  { wordTranslated: "	configuration n. 	", czWord: "	konfigurace   	" },
  { wordTranslated: "	confine v. 	", czWord: "	omezit   	" },
  { wordTranslated: "	confirmation n. 	", czWord: "	potvrzení   	" },
  { wordTranslated: "	confront v. 	", czWord: "	konfrontovat   	" },
  { wordTranslated: "	confrontation n. 	", czWord: "	konfrontace   	" },
  { wordTranslated: "	congratulate v. 	", czWord: "	gratuluji   	" },
  { wordTranslated: "	congregation n. 	", czWord: "	sbor   	" },
  { wordTranslated: "	congressional adj. 	", czWord: "	kongresový   	" },
  { wordTranslated: "	conquer v. 	", czWord: "	dobýt   	" },
  { wordTranslated: "	conscience n. 	", czWord: "	svědomí   	" },
  { wordTranslated: "	consciousness n. 	", czWord: "	vědomí   	" },
  { wordTranslated: "	consecutive adj. 	", czWord: "	po sobě jdoucí   	" },
  { wordTranslated: "	consensus n. 	", czWord: "	konsensus   	" },
  { wordTranslated: "	consent n., v. 	", czWord: "	souhlas     	" },
  { wordTranslated: "	conserve v. 	", czWord: "	konzervovat   	" },
  { wordTranslated: "	consistency n. 	", czWord: "	konzistence   	" },
  { wordTranslated: "	consolidate v. 	", czWord: "	konsolidovat   	" },
  { wordTranslated: "	constituency n. 	", czWord: "	volební obvod   	" },
  { wordTranslated: "	constitute v. 	", czWord: "	tvoří   	" },
  { wordTranslated: "	constitution n. 	", czWord: "	ústava   	" },
  { wordTranslated: "	constitutional adj. 	", czWord: "	ústavní   	" },
  { wordTranslated: "	constraint n. 	", czWord: "	omezení   	" },
  { wordTranslated: "	consultation n. 	", czWord: "	konzultace   	" },
  { wordTranslated: "	contemplate v. 	", czWord: "	rozjímat   	" },
  { wordTranslated: "	contempt n. 	", czWord: "	pohrdání   	" },
  { wordTranslated: "	contend v. 	", czWord: "	zápasit   	" },
  { wordTranslated: "	contender n. 	", czWord: "	uchazeč   	" },
  { wordTranslated: "	content2 adj. 	", czWord: "	obsah2   	" },
  { wordTranslated: "	contention n. 	", czWord: "	spor   	" },
  { wordTranslated: "	continually adv. 	", czWord: "	neustále   	" },
  { wordTranslated: "	contractor n. 	", czWord: "	dodavatel   	" },
  { wordTranslated: "	contradiction n. 	", czWord: "	rozpor   	" },
  { wordTranslated: "	contrary adj., n. 	", czWord: "	opačný   	" },
  { wordTranslated: "	contributor n. 	", czWord: "	přispěvatel   	" },
  { wordTranslated: "	conversion n. 	", czWord: "	konverze   	" },
  { wordTranslated: "	convict v. 	", czWord: "	odsouzený   	" },
  { wordTranslated: "	conviction n. 	", czWord: "	přesvědčení   	" },
  { wordTranslated: "	cooperate v. 	", czWord: "	spolupracovat   	" },
  { wordTranslated: "	cooperative adj. 	", czWord: "	družstevní   	" },
  { wordTranslated: "	coordinate v. 	", czWord: "	koordinovat   	" },
  { wordTranslated: "	coordination n. 	", czWord: "	koordinace   	" },
  { wordTranslated: "	coordinator n. 	", czWord: "	koordinátor   	" },
  { wordTranslated: "	cop n. 	", czWord: "	policajt   	" },
  { wordTranslated: "	copper n. 	", czWord: "	měď   	" },
  { wordTranslated: "	copyright n. 	", czWord: "	autorská práva   	" },
  { wordTranslated: "	correction n. 	", czWord: "	oprava   	" },
  { wordTranslated: "	correlate v. 	", czWord: "	korelovat   	" },
  { wordTranslated: "	correlation n. 	", czWord: "	korelace   	" },
  { wordTranslated: "	correspond v. 	", czWord: "	odpovídat   	" },
  { wordTranslated: "	correspondence n. 	", czWord: "	korespondence   	" },
  { wordTranslated: "	correspondent n. 	", czWord: "	dopisovatel   	" },
  { wordTranslated: "	corresponding adj. 	", czWord: "	odpovídající   	" },
  { wordTranslated: "	corrupt adj. 	", czWord: "	zkorumpovaný   	" },
  { wordTranslated: "	corruption n. 	", czWord: "	korupce   	" },
  { wordTranslated: "	costly adj. 	", czWord: "	nákladný   	" },
  { wordTranslated: "	councillor n. 	", czWord: "	radní   	" },
  { wordTranslated: "	counselling n. 	", czWord: "	poradenství   	" },
  { wordTranslated: "	counsellor n. 	", czWord: "	poradce   	" },
  {
    wordTranslated: "	counter (argue against) v. 	",
    czWord: "	odporovat (argumentovat proti)   	",
  },
  { wordTranslated: "	counterpart n. 	", czWord: "	protějšek   	" },
  { wordTranslated: "	countless adj. 	", czWord: "	bezpočet   	" },
  { wordTranslated: "	coup n. 	", czWord: "	převrat   	" },
  { wordTranslated: "	courtesy n. 	", czWord: "	zdvořilost   	" },
  { wordTranslated: "	craft v. 	", czWord: "	řemeslo   	" },
  { wordTranslated: "	crawl v. 	", czWord: "	plazit se   	" },
  { wordTranslated: "	creator n. 	", czWord: "	tvůrce   	" },
  { wordTranslated: "	credibility n. 	", czWord: "	důvěryhodnost   	" },
  { wordTranslated: "	credible adj. 	", czWord: "	věrohodný   	" },
  { wordTranslated: "	creep v. 	", czWord: "	plížit se   	" },
  { wordTranslated: "	critique n. 	", czWord: "	kritika   	" },
  { wordTranslated: "	crown n. 	", czWord: "	koruna   	" },
  { wordTranslated: "	crude adj. 	", czWord: "	hrubý   	" },
  { wordTranslated: "	crush v. 	", czWord: "	rozdrtit   	" },
  { wordTranslated: "	crystal n. 	", czWord: "	krystal   	" },
  { wordTranslated: "	cult n., adj. 	", czWord: "	kult    	" },
  { wordTranslated: "	cultivate v. 	", czWord: "	pěstovat   	" },
  { wordTranslated: "	curiosity n. 	", czWord: "	zvědavost   	" },
  { wordTranslated: "	custody n. 	", czWord: "	opatrovnictví   	" },
  { wordTranslated: "	cutting n. 	", czWord: "	řezání   	" },
  { wordTranslated: "	cynical adj. 	", czWord: "	cynický   	" },
  { wordTranslated: "	dam n. 	", czWord: "	sakra. 	" },
  { wordTranslated: "	damaging adj. 	", czWord: "	poškozující   	" },
  { wordTranslated: "	dawn n. 	", czWord: "	svítání   	" },
  { wordTranslated: "	debris n. 	", czWord: "	trosky   	" },
  { wordTranslated: "	debut n. 	", czWord: "	debut   	" },
  { wordTranslated: "	decision-making n. 	", czWord: "	rozhodování   	" },
  { wordTranslated: "	decisive adj. 	", czWord: "	rozhodný   	" },
  { wordTranslated: "	declaration n. 	", czWord: "	prohlášení 	" },
  { wordTranslated: "	dedicated adj. 	", czWord: "	oddaný   	" },
  { wordTranslated: "	dedication n. 	", czWord: "	věnování   	" },
  { wordTranslated: "	deed n. 	", czWord: "	listina   	" },
  { wordTranslated: "	deem v. 	", czWord: "	považovat   	" },
  { wordTranslated: "	default n. 	", czWord: "	výchozí   	" },
  { wordTranslated: "	defect n. 	", czWord: "	vada   	" },
  { wordTranslated: "	defensive adj. 	", czWord: "	obranný   	" },
  { wordTranslated: "	deficiency n. 	", czWord: "	nedostatek   	" },
  { wordTranslated: "	deficit n. 	", czWord: "	deficit   	" },
  { wordTranslated: "	defy v. 	", czWord: "	vzdorovat   	" },
  { wordTranslated: "	delegate n. 	", czWord: "	delegát   	" },
  { wordTranslated: "	delegation n. 	", czWord: "	delegace   	" },
  { wordTranslated: "	delicate adj. 	", czWord: "	jemný   	" },
  { wordTranslated: "	demon n. 	", czWord: "	démon   	" },
  { wordTranslated: "	denial n. 	", czWord: "	popření   	" },
  { wordTranslated: "	denounce v. 	", czWord: "	odsuzovat   	" },
  { wordTranslated: "	dense adj. 	", czWord: "	hustý   	" },
  { wordTranslated: "	density n. 	", czWord: "	hustota   	" },
  { wordTranslated: "	dependence n. 	", czWord: "	závislost   	" },
  { wordTranslated: "	depict v. 	", czWord: "	zobrazovat   	" },
  { wordTranslated: "	deploy v. 	", czWord: "	nasadit   	" },
  { wordTranslated: "	deployment n. 	", czWord: "	nasazení   	" },
  { wordTranslated: "	deposit v. 	", czWord: "	vklad   	" },
  { wordTranslated: "	deprive v. 	", czWord: "	zbavit   	" },
  { wordTranslated: "	deputy n. 	", czWord: "	zástupce   	" },
  { wordTranslated: "	descend v. 	", czWord: "	sestoupit   	" },
  { wordTranslated: "	descent n. 	", czWord: "	sestup   	" },
  { wordTranslated: "	designate v. 	", czWord: "	jmenovat   	" },
  { wordTranslated: "	desirable adj. 	", czWord: "	žádoucí   	" },
  { wordTranslated: "	desktop n. 	", czWord: "	desktop   	" },
  { wordTranslated: "	destructive adj. 	", czWord: "	ničivý   	" },
  { wordTranslated: "	detain v. 	", czWord: "	zadržet   	" },
  { wordTranslated: "	detection n. 	", czWord: "	detekce   	" },
  { wordTranslated: "	detention n. 	", czWord: "	zadržení   	" },
  { wordTranslated: "	deteriorate v. 	", czWord: "	zhoršit se   	" },
  { wordTranslated: "	devastate v. 	", czWord: "	devastovat   	" },
  { wordTranslated: "	devil n. 	", czWord: "	čert   	" },
  { wordTranslated: "	devise v. 	", czWord: "	vymyslet   	" },
  { wordTranslated: "	diagnose v. 	", czWord: "	diagnostikovat   	" },
  { wordTranslated: "	diagnosis n. 	", czWord: "	diagnóza   	" },
  { wordTranslated: "	dictate v. 	", czWord: "	diktovat   	" },
  { wordTranslated: "	dictator n. 	", czWord: "	diktátor   	" },
  { wordTranslated: "	differentiate v. 	", czWord: "	odlišit   	" },
  { wordTranslated: "	dignity n. 	", czWord: "	důstojnost   	" },
  { wordTranslated: "	dilemma n. 	", czWord: "	dilema   	" },
  { wordTranslated: "	dimension n. 	", czWord: "	rozměr   	" },
  { wordTranslated: "	diminish v. 	", czWord: "	zmenšit   	" },
  { wordTranslated: "	dip v. 	", czWord: "	dip   	" },
  { wordTranslated: "	diplomat n. 	", czWord: "	diplomat   	" },
  { wordTranslated: "	diplomatic n. 	", czWord: "	diplomatický   	" },
  { wordTranslated: "	directory n. 	", czWord: "	adresář   	" },
  { wordTranslated: "	disastrous adj. 	", czWord: "	katastrofální   	" },
  { wordTranslated: "	discard v. 	", czWord: "	odhodit   	" },
  { wordTranslated: "	discharge v. 	", czWord: "	vypouštění   	" },
  { wordTranslated: "	disclose v. 	", czWord: "	zveřejnit   	" },
  { wordTranslated: "	disclosure n. 	", czWord: "	zveřejnění   	" },
  { wordTranslated: "	discourse n. 	", czWord: "	diskurz   	" },
  { wordTranslated: "	discretion n. 	", czWord: "	diskrétnost   	" },
  { wordTranslated: "	discrimination n. 	", czWord: "	diskriminace   	" },
  { wordTranslated: "	dismissal n. 	", czWord: "	výpověď   	" },
  { wordTranslated: "	displace v. 	", czWord: "	přemístit   	" },
  { wordTranslated: "	disposal n. 	", czWord: "	likvidace   	" },
  { wordTranslated: "	dispose v. 	", czWord: "	disponovat   	" },
  { wordTranslated: "	dispute n., v. 	", czWord: "	spor    	" },
  { wordTranslated: "	disrupt v. 	", czWord: "	narušit   	" },
  { wordTranslated: "	disruption n. 	", czWord: "	přerušení   	" },
  { wordTranslated: "	dissolve v. 	", czWord: "	rozpustit   	" },
  { wordTranslated: "	distinction n. 	", czWord: "	rozlišení   	" },
  { wordTranslated: "	distinctive adj. 	", czWord: "	výrazný   	" },
  { wordTranslated: "	distort v. 	", czWord: "	deformovat   	" },
  { wordTranslated: "	distress n., v. 	", czWord: "	tíseň   	" },
  { wordTranslated: "	disturbing adj. 	", czWord: "	rušivý   	" },
  { wordTranslated: "	divert v. 	", czWord: "	odklonit   	" },
  { wordTranslated: "	divine adj. 	", czWord: "	božský   	" },
  { wordTranslated: "	doctrine n. 	", czWord: "	doktrína   	" },
  { wordTranslated: "	documentation n. 	", czWord: "	dokumentace   	" },
  { wordTranslated: "	domain n. 	", czWord: "	doména   	" },
  { wordTranslated: "	dominance n. 	", czWord: "	dominance   	" },
  { wordTranslated: "	donor n. 	", czWord: "	dárce   	" },
  { wordTranslated: "	dose n. 	", czWord: "	dávka   	" },
  { wordTranslated: "	drain v. 	", czWord: "	odvod   	" },
  { wordTranslated: "	drift v. 	", czWord: "	drift   	" },
  { wordTranslated: "	driving adj. 	", czWord: "	jízdní   	" },
  { wordTranslated: "	drown v. 	", czWord: "	utopit se   	" },
  { wordTranslated: "	dual adj. 	", czWord: "	duální   	" },
  { wordTranslated: "	dub v. 	", czWord: "	dub   	" },
  { wordTranslated: "	dumb adj. 	", czWord: "	němý   	" },
  { wordTranslated: "	duo n. 	", czWord: "	duo   	" },
  { wordTranslated: "	dynamic n. 	", czWord: "	dynamický   	" },
  { wordTranslated: "	eager adj. 	", czWord: "	dychtivý   	" },
  { wordTranslated: "	earnings n. 	", czWord: "	výdělek   	" },
  { wordTranslated: "	ease n., v. 	", czWord: "	lehkost     	" },
  { wordTranslated: "	echo v., n. 	", czWord: "	echo     	" },
  { wordTranslated: "	ecological adj. 	", czWord: "	ekologický   	" },
  { wordTranslated: "	educator n. 	", czWord: "	vychovatel   	" },
  { wordTranslated: "	effectiveness n. 	", czWord: "	účinnost   	" },
  { wordTranslated: "	efficiency n. 	", czWord: "	účinnost   	" },
  { wordTranslated: "	ego n. 	", czWord: "	ego   	" },
  { wordTranslated: "	elaborate adj. 	", czWord: "	propracovaný   	" },
  { wordTranslated: "	electoral adj. 	", czWord: "	volební   	" },
  { wordTranslated: "	elevate v. 	", czWord: "	pozvednout   	" },
  { wordTranslated: "	eligible adj. 	", czWord: "	způsobilý   	" },
  { wordTranslated: "	elite n. 	", czWord: "	elita   	" },
  { wordTranslated: "	embark v. 	", czWord: "	nalodit se   	" },
  { wordTranslated: "	embarrassment n. 	", czWord: "	rozpaky   	" },
  { wordTranslated: "	embassy n. 	", czWord: "	velvyslanectví   	" },
  { wordTranslated: "	embed v. 	", czWord: "	vložit   	" },
  { wordTranslated: "	embody v. 	", czWord: "	ztělesňovat   	" },
  { wordTranslated: "	emergence n. 	", czWord: "	vznik   	" },
  { wordTranslated: "	empirical adj. 	", czWord: "	empirický   	" },
  { wordTranslated: "	empower v. 	", czWord: "	zmocnit   	" },
  { wordTranslated: "	enact v. 	", czWord: "	uzákonit   	" },
  { wordTranslated: "	encompass v. 	", czWord: "	obsáhnout   	" },
  { wordTranslated: "	encouragement n. 	", czWord: "	povzbuzení   	" },
  { wordTranslated: "	encouraging adj. 	", czWord: "	povzbuzující   	" },
  { wordTranslated: "	endeavour n. 	", czWord: "	snaha   	" },
  { wordTranslated: "	endless adj. 	", czWord: "	nekonečný   	" },
  { wordTranslated: "	endorse v. 	", czWord: "	podporovat   	" },
  { wordTranslated: "	endorsement n. 	", czWord: "	potvrzení   	" },
  { wordTranslated: "	endure v. 	", czWord: "	vydržet   	" },
  { wordTranslated: "	enforce v. 	", czWord: "	prosadit   	" },
  { wordTranslated: "	enforcement n. 	", czWord: "	vymáhání   	" },
  { wordTranslated: "	engagement n. 	", czWord: "	angažmá   	" },
  { wordTranslated: "	engaging adj. 	", czWord: "	poutavý   	" },
  { wordTranslated: "	enquire v. 	", czWord: "	zeptat se   	" },
  { wordTranslated: "	enrich v. 	", czWord: "	obohatit   	" },
  { wordTranslated: "	enrol v. 	", czWord: "	přihlásit se   	" },
  { wordTranslated: "	ensue v. 	", czWord: "	následovat   	" },
  { wordTranslated: "	enterprise n. 	", czWord: "	podnik   	" },
  { wordTranslated: "	enthusiast n. 	", czWord: "	nadšenec   	" },
  { wordTranslated: "	entitle v. 	", czWord: "	opravňovat   	" },
  { wordTranslated: "	entity n. 	", czWord: "	entita   	" },
  { wordTranslated: "	epidemic n. 	", czWord: "	epidemie   	" },
  { wordTranslated: "	equality n. 	", czWord: "	rovnost   	" },
  { wordTranslated: "	equation n. 	", czWord: "	rovnice   	" },
  { wordTranslated: "	erect v. 	", czWord: "	vztyčený   	" },
  { wordTranslated: "	escalate v. 	", czWord: "	eskalovat   	" },
  { wordTranslated: "	essence n. 	", czWord: "	esence   	" },
  { wordTranslated: "	establishment n. 	", czWord: "	provozovna   	" },
  { wordTranslated: "	eternal adj. 	", czWord: "	věčný   	" },
  { wordTranslated: "	evacuate v. 	", czWord: "	evakuovat   	" },
  { wordTranslated: "	evoke v. 	", czWord: "	vyvolat   	" },
  { wordTranslated: "	evolutionary adj. 	", czWord: "	evoluční   	" },
  { wordTranslated: "	exaggerate v. 	", czWord: "	přehánět   	" },
  { wordTranslated: "	excellence n. 	", czWord: "	excelence   	" },
  { wordTranslated: "	exceptional adj. 	", czWord: "	výjimečný   	" },
  { wordTranslated: "	excess n., adj. 	", czWord: "	nadbytek    	" },
  { wordTranslated: "	exclusion n. 	", czWord: "	vyloučení   	" },
  { wordTranslated: "	exclusive adj. 	", czWord: "	výhradní   	" },
  { wordTranslated: "	exclusively adv. 	", czWord: "	výhradně  	" },
  { wordTranslated: "	execute v. 	", czWord: "	provést   	" },
  { wordTranslated: "	execution n. 	", czWord: "	provedení   	" },
  { wordTranslated: "	exert v. 	", czWord: "	vynaložit   	" },
  { wordTranslated: "	exile n. 	", czWord: "	vyhnanství   	" },
  { wordTranslated: "	exit v. 	", czWord: "	výstup   	" },
  { wordTranslated: "	expenditure n. 	", czWord: "	výdaj   	" },
  { wordTranslated: "	experimental adj. 	", czWord: "	experimentální   	" },
  { wordTranslated: "	expire v. 	", czWord: "	vypršet   	" },
  { wordTranslated: "	explicit adj. 	", czWord: "	výslovný   	" },
  { wordTranslated: "	explicitly adv. 	", czWord: "	výslovně  	" },
  { wordTranslated: "	exploitation n. 	", czWord: "	vykořisťování   	" },
  { wordTranslated: "	explosive adj., n. 	", czWord: "	výbušný    	" },
  { wordTranslated: "	extract v. 	", czWord: "	extrakt   	" },
  { wordTranslated: "	extremist n. 	", czWord: "	extremistický   	" },
  { wordTranslated: "	facilitate v. 	", czWord: "	usnadnit   	" },
  { wordTranslated: "	faction n. 	", czWord: "	frakce   	" },
  { wordTranslated: "	faculty n. 	", czWord: "	fakulta   	" },
  { wordTranslated: "	fade v. 	", czWord: "	vyblednout   	" },
  { wordTranslated: "	fairness n. 	", czWord: "	spravedlnost   	" },
  { wordTranslated: "	fatal adj. 	", czWord: "	osudný   	" },
  { wordTranslated: "	fate n. 	", czWord: "	osud   	" },
  { wordTranslated: "	favourable adj. 	", czWord: "	příznivý   	" },
  { wordTranslated: "	feat n. 	", czWord: "	výkon   	" },
  { wordTranslated: "	feminist adj., n. 	", czWord: "	feministický    	" },
  { wordTranslated: "	fibre n. 	", czWord: "	vlákno   	" },
  { wordTranslated: "	fierce adj. 	", czWord: "	prudký   	" },
  { wordTranslated: "	film-maker n. 	", czWord: "	filmař   	" },
  { wordTranslated: "	filter n., v. 	", czWord: "	filtr     	" },
  { wordTranslated: "	fine n., v. 	", czWord: "	pokuta   	" },
  { wordTranslated: "	firearm n. 	", czWord: "	střelná zbraň   	" },
  { wordTranslated: "	fit n. 	", czWord: "	fit   	" },
  { wordTranslated: "	fixture n. 	", czWord: "	přípravek   	" },
  { wordTranslated: "	flaw n. 	", czWord: "	vada   	" },
  { wordTranslated: "	flawed adj. 	", czWord: "	vadný   	" },
  { wordTranslated: "	flee v. 	", czWord: "	utéct   	" },
  { wordTranslated: "	fleet n. 	", czWord: "	flotila   	" },
  { wordTranslated: "	flesh n. 	", czWord: "	maso   	" },
  { wordTranslated: "	flexibility n. 	", czWord: "	flexibilita   	" },
  { wordTranslated: "	flourish v. 	", czWord: "	vzkvétat   	" },
  { wordTranslated: "	fluid n. 	", czWord: "	tekutina   	" },
  { wordTranslated: "	footage n. 	", czWord: "	záběry   	" },
  { wordTranslated: "	foreigner n. 	", czWord: "	cizinec   	" },
  { wordTranslated: "	forge v. 	", czWord: "	kovář   	" },
  { wordTranslated: "	formula n. 	", czWord: "	vzorec   	" },
  { wordTranslated: "	formulate v. 	", czWord: "	formulovat   	" },
  { wordTranslated: "	forth adv. 	", czWord: "	dále ad  	" },
  { wordTranslated: "	forthcoming adj. 	", czWord: "	nastávající   	" },
  { wordTranslated: "	foster v. 	", czWord: "	pěstovat   	" },
  { wordTranslated: "	fragile adj. 	", czWord: "	křehký   	" },
  { wordTranslated: "	franchise n. 	", czWord: "	franšíza   	" },
  { wordTranslated: "	frankly adv. 	", czWord: "	upřímně řečeno ad  	" },
  { wordTranslated: "	frustrated adj. 	", czWord: "	frustrovaný   	" },
  { wordTranslated: "	frustrating adj. 	", czWord: "	frustrující   	" },
  { wordTranslated: "	frustration n. 	", czWord: "	frustrace   	" },
  { wordTranslated: "	functional adj. 	", czWord: "	funkční   	" },
  { wordTranslated: "	fundraising n. 	", czWord: "	fundraising   	" },
  { wordTranslated: "	funeral n. 	", czWord: "	pohřeb   	" },
  { wordTranslated: "	gallon n. 	", czWord: "	galon   	" },
  { wordTranslated: "	gambling n. 	", czWord: "	hazardní hry   	" },
  { wordTranslated: "	gathering n. 	", czWord: "	shromáždění   	" },
  { wordTranslated: "	gaze n., v. 	", czWord: "	pohled    	" },
  { wordTranslated: "	gear n. 	", czWord: "	převod   	" },
  { wordTranslated: "	generic adj. 	", czWord: "	druhový   	" },
  { wordTranslated: "	genocide n. 	", czWord: "	genocida   	" },
  { wordTranslated: "	glance n., v. 	", czWord: "	pohled  ,   	" },
  { wordTranslated: "	glimpse n. 	", czWord: "	letmý pohled   	" },
  { wordTranslated: "	glorious adj. 	", czWord: "	slavný   	" },
  { wordTranslated: "	glory n. 	", czWord: "	sláva   	" },
  { wordTranslated: "	governance n. 	", czWord: "	řízení   	" },
  { wordTranslated: "	grace n. 	", czWord: "	milost   	" },
  { wordTranslated: "	grasp v., n. 	", czWord: "	uchopit     	" },
  { wordTranslated: "	grave (for dead person) n. 	", czWord: "	hrob (pro mrtvého)   	" },
  { wordTranslated: "	grave (serious) adj. 	", czWord: "	hrobový (vážný)   	" },
  { wordTranslated: "	gravity n. 	", czWord: "	gravitace   	" },
  { wordTranslated: "	grid n. 	", czWord: "	mřížka   	" },
  { wordTranslated: "	grief n. 	", czWord: "	smutek   	" },
  { wordTranslated: "	grin v., n. 	", czWord: "	úsměv     	" },
  { wordTranslated: "	grind v. 	", czWord: "	brousit   	" },
  { wordTranslated: "	grip n., v. 	", czWord: "	úchop    	" },
  { wordTranslated: "	gross adj. 	", czWord: "	hrubý   	" },
  { wordTranslated: "	guerrilla n. 	", czWord: "	partyzán   	" },
  { wordTranslated: "	guidance n. 	", czWord: "	vedení   	" },
  { wordTranslated: "	guilt n. 	", czWord: "	vina   	" },
  { wordTranslated: "	gut n. 	", czWord: "	střevo   	" },
  { wordTranslated: "	hail v. 	", czWord: "	krupobití   	" },
  { wordTranslated: "	halfway adv. 	", czWord: "	napůl  	" },
  { wordTranslated: "	halt v., n. 	", czWord: "	zastavit    	" },
  { wordTranslated: "	handful n. 	", czWord: "	hrst   	" },
  { wordTranslated: "	handling n. 	", czWord: "	manipulace   	" },
  { wordTranslated: "	handy adj. 	", czWord: "	šikovný   	" },
  { wordTranslated: "	harassment n. 	", czWord: "	obtěžování   	" },
  { wordTranslated: "	hardware n. 	", czWord: "	hardware   	" },
  { wordTranslated: "	harmony n. 	", czWord: "	harmonie   	" },
  { wordTranslated: "	harsh adj. 	", czWord: "	drsný   	" },
  { wordTranslated: "	harvest n., v. 	", czWord: "	sklizeň    	" },
  { wordTranslated: "	hatred n. 	", czWord: "	nenávist   	" },
  { wordTranslated: "	haunt v. 	", czWord: "	strašit   	" },
  { wordTranslated: "	hazard n. 	", czWord: "	nebezpečí   	" },
  { wordTranslated: "	heighten v. 	", czWord: "	zvýšit   	" },
  { wordTranslated: "	heritage n. 	", czWord: "	dědictví   	" },
  { wordTranslated: "	hierarchy n. 	", czWord: "	hierarchie   	" },
  { wordTranslated: "	high-profile adj. 	", czWord: "	vysoký profil   	" },
  { wordTranslated: "	hint n., v. 	", czWord: "	nápověda     	" },
  { wordTranslated: "	homeland n. 	", czWord: "	vlast   	" },
  { wordTranslated: "	hook v. 	", czWord: "	háček   	" },
  { wordTranslated: "	hopeful adj. 	", czWord: "	nadějný   	" },
  { wordTranslated: "	horizon n. 	", czWord: "	horizont   	" },
  { wordTranslated: "	horn n. 	", czWord: "	roh   	" },
  { wordTranslated: "	hostage n. 	", czWord: "	rukojmí   	" },
  { wordTranslated: "	hostile adj. 	", czWord: "	nepřátelský   	" },
  { wordTranslated: "	hostility n. 	", czWord: "	nepřátelství   	" },
  { wordTranslated: "	humanitarian adj. 	", czWord: "	humanitní   	" },
  { wordTranslated: "	humanity n. 	", czWord: "	lidskost   	" },
  { wordTranslated: "	humble adj. 	", czWord: "	pokorný   	" },
  { wordTranslated: "	hydrogen n. 	", czWord: "	vodík   	" },
  { wordTranslated: "	identification n. 	", czWord: "	identifikace   	" },
  { wordTranslated: "	ideological adj. 	", czWord: "	ideologický   	" },
  { wordTranslated: "	ideology n. 	", czWord: "	ideologie   	" },
  { wordTranslated: "	idiot n. 	", czWord: "	idiot   	" },
  { wordTranslated: "	ignorance n. 	", czWord: "	neznalost   	" },
  { wordTranslated: "	imagery n. 	", czWord: "	snímky   	" },
  { wordTranslated: "	immense adj. 	", czWord: "	nesmírný   	" },
  { wordTranslated: "	imminent adj. 	", czWord: "	hrozící   	" },
  { wordTranslated: "	implementation n. 	", czWord: "	realizace   	" },
  { wordTranslated: "	imprison v. 	", czWord: "	uvěznit   	" },
  { wordTranslated: "	imprisonment n. 	", czWord: "	vězení   	" },
  { wordTranslated: "	inability n. 	", czWord: "	neschopnost   	" },
  { wordTranslated: "	inadequate adj. 	", czWord: "	neadekvátní   	" },
  { wordTranslated: "	inappropriate adj. 	", czWord: "	nevhodný   	" },
  { wordTranslated: "	incidence n. 	", czWord: "	výskyt   	" },
  { wordTranslated: "	inclined adj. 	", czWord: "	nakloněný   	" },
  { wordTranslated: "	inclusion n. 	", czWord: "	zařazení   	" },
  { wordTranslated: "	incur v. 	", czWord: "	vyvolat   	" },
  { wordTranslated: "	indicator n. 	", czWord: "	indikátor   	" },
  { wordTranslated: "	indictment n. 	", czWord: "	obžaloba   	" },
  { wordTranslated: "	indigenous adj. 	", czWord: "	domorodý   	" },
  { wordTranslated: "	induce v. 	", czWord: "	vyvolat   	" },
  { wordTranslated: "	indulge v. 	", czWord: "	dopřát si   	" },
  { wordTranslated: "	inequality n. 	", czWord: "	nerovnost   	" },
  { wordTranslated: "	infamous adj. 	", czWord: "	nechvalně známý   	" },
  { wordTranslated: "	infant n. 	", czWord: "	kojenec   	" },
  { wordTranslated: "	infect v. 	", czWord: "	infikovat   	" },
  { wordTranslated: "	inflict v. 	", czWord: "	způsobit   	" },
  { wordTranslated: "	influential adj. 	", czWord: "	vlivný   	" },
  { wordTranslated: "	inherent adj. 	", czWord: "	inherentní   	" },
  { wordTranslated: "	inhibit v. 	", czWord: "	inhibovat   	" },
  { wordTranslated: "	initiate v. 	", czWord: "	zahájit   	" },
  { wordTranslated: "	inject v. 	", czWord: "	injekci   	" },
  { wordTranslated: "	injection n. 	", czWord: "	injekce   	" },
  { wordTranslated: "	injustice n. 	", czWord: "	nespravedlnost   	" },
  { wordTranslated: "	inmate n. 	", czWord: "	chovanec   	" },
  { wordTranslated: "	insertion n. 	", czWord: "	vložení   	" },
  { wordTranslated: "	insider n. 	", czWord: "	zasvěcenec   	" },
  { wordTranslated: "	inspect v. 	", czWord: "	zkontrolovat   	" },
  { wordTranslated: "	inspection n. 	", czWord: "	kontrola   	" },
  { wordTranslated: "	inspiration n. 	", czWord: "	inspirace   	" },
  { wordTranslated: "	instinct n. 	", czWord: "	instinkt   	" },
  { wordTranslated: "	institutional adj. 	", czWord: "	institucionální   	" },
  { wordTranslated: "	instruct v. 	", czWord: "	poučit   	" },
  { wordTranslated: "	instrumental adj. 	", czWord: "	instrumentální   	" },
  { wordTranslated: "	insufficient adj. 	", czWord: "	nedostatečný   	" },
  { wordTranslated: "	insult n., v. 	", czWord: "	urážka     	" },
  { wordTranslated: "	intact adj. 	", czWord: "	neporušený   	" },
  { wordTranslated: "	intake n. 	", czWord: "	příjem   	" },
  { wordTranslated: "	integral adj. 	", czWord: "	integrální   	" },
  { wordTranslated: "	integrated adj. 	", czWord: "	integrovaný   	" },
  { wordTranslated: "	integration n. 	", czWord: "	integrace   	" },
  { wordTranslated: "	integrity n. 	", czWord: "	integrita   	" },
  { wordTranslated: "	intellectual n. 	", czWord: "	intelektuální   	" },
  { wordTranslated: "	intensify v. 	", czWord: "	zesílit   	" },
  { wordTranslated: "	intensity n. 	", czWord: "	intenzita   	" },
  { wordTranslated: "	intensive adj. 	", czWord: "	intenzivní   	" },
  { wordTranslated: "	intent n. 	", czWord: "	záměr   	" },
  { wordTranslated: "	interactive adj. 	", czWord: "	interaktivní   	" },
  { wordTranslated: "	interface n. 	", czWord: "	rozhraní   	" },
  { wordTranslated: "	interfere v. 	", czWord: "	zasahovat   	" },
  { wordTranslated: "	interference n. 	", czWord: "	rušení   	" },
  { wordTranslated: "	interim adj. 	", czWord: "	prozatímní   	" },
  { wordTranslated: "	interior adj., n. 	", czWord: "	vnitřní     	" },
  { wordTranslated: "	intermediate adj. 	", czWord: "	střední   	" },
  { wordTranslated: "	intervene v. 	", czWord: "	zasahovat   	" },
  { wordTranslated: "	intervention n. 	", czWord: "	zásah   	" },
  { wordTranslated: "	intimate adj. 	", czWord: "	intimní   	" },
  { wordTranslated: "	intriguing adj. 	", czWord: "	poutavý   	" },
  { wordTranslated: "	investigator n. 	", czWord: "	vyšetřovatel   	" },
  { wordTranslated: "	invisible adj. 	", czWord: "	neviditelný   	" },
  { wordTranslated: "	invoke v. 	", czWord: "	vyvolat   	" },
  { wordTranslated: "	involvement n. 	", czWord: "	zapojení   	" },
  { wordTranslated: "	ironic adj. 	", czWord: "	ironický   	" },
  { wordTranslated: "	ironically adv. 	", czWord: "	ironicky   	" },
  { wordTranslated: "	irony n. 	", czWord: "	ironie   	" },
  { wordTranslated: "	irrelevant adj. 	", czWord: "	nepodstatný   	" },
  { wordTranslated: "	isolation n. 	", czWord: "	izolace   	" },
  { wordTranslated: "	judicial adj. 	", czWord: "	soudní   	" },
  { wordTranslated: "	junction n. 	", czWord: "	křižovatka   	" },
  { wordTranslated: "	jurisdiction n. 	", czWord: "	jurisdikce   	" },
  { wordTranslated: "	just adj. 	", czWord: "	jen   	" },
  { wordTranslated: "	justification n. 	", czWord: "	odůvodnění   	" },
  { wordTranslated: "	kidnap v. 	", czWord: "	unést   	" },
  { wordTranslated: "	kidney n. 	", czWord: "	ledvina   	" },
  { wordTranslated: "	kingdom n. 	", czWord: "	království   	" },
  { wordTranslated: "	lad n. 	", czWord: "	chlapec   	" },
  { wordTranslated: "	landlord n. 	", czWord: "	pronajímatel   	" },
  { wordTranslated: "	landmark n. 	", czWord: "	orientační bod   	" },
  { wordTranslated: "	lap n. 	", czWord: "	kolo   	" },
  { wordTranslated: "	large-scale adj. 	", czWord: "	velkoplošný   	" },
  { wordTranslated: "	laser n. 	", czWord: "	laser   	" },
  { wordTranslated: "	latter adj., n. 	", czWord: "	poslední     	" },
  { wordTranslated: "	lawn n. 	", czWord: "	trávník  	" },
  { wordTranslated: "	lawsuit n. 	", czWord: "	žaloba   	" },
  { wordTranslated: "	layout n. 	", czWord: "	rozložení   	" },
  { wordTranslated: "	leak v., n. 	", czWord: "	únik    	" },
  { wordTranslated: "	leap v., n. 	", czWord: "	skok    	" },
  { wordTranslated: "	legacy n. 	", czWord: "	dědictví   	" },
  { wordTranslated: "	legendary adj. 	", czWord: "	legendární   	" },
  { wordTranslated: "	legislation n. 	", czWord: "	legislativa   	" },
  { wordTranslated: "	legislative adj. 	", czWord: "	legislativní   	" },
  { wordTranslated: "	legislature n. 	", czWord: "	zákonodárný sbor   	" },
  { wordTranslated: "	legitimate adj. 	", czWord: "	legitimní   	" },
  { wordTranslated: "	lengthy adj. 	", czWord: "	dlouhý   	" },
  { wordTranslated: "	lesbian adj. 	", czWord: "	lesbický   	" },
  { wordTranslated: "	lesser adj. 	", czWord: "	menší   	" },
  { wordTranslated: "	lethal adj. 	", czWord: "	smrtelný   	" },
  { wordTranslated: "	liable adj. 	", czWord: "	odpovědný   	" },
  { wordTranslated: "	liberal adj., n. 	", czWord: "	liberální     	" },
  { wordTranslated: "	liberation n. 	", czWord: "	osvobození   	" },
  { wordTranslated: "	liberty n. 	", czWord: "	svoboda   	" },
  { wordTranslated: "	license v. 	", czWord: "	licence   	" },
  { wordTranslated: "	lifelong adj. 	", czWord: "	doživotní   	" },
  { wordTranslated: "	likelihood n. 	", czWord: "	pravděpodobnost   	" },
  { wordTranslated: "	limb n. 	", czWord: "	končetina   	" },
  { wordTranslated: "	linear adj. 	", czWord: "	lineární   	" },
  { wordTranslated: "	line-up n. 	", czWord: "	sestava   	" },
  { wordTranslated: "	linger v. 	", czWord: "	zdržovat se   	" },
  { wordTranslated: "	listing n. 	", czWord: "	výpis   	" },
  { wordTranslated: "	literacy n. 	", czWord: "	gramotnost   	" },
  { wordTranslated: "	liver n. 	", czWord: "	játra   	" },
  { wordTranslated: "	lobby n., v. 	", czWord: "	lobby     	" },
  { wordTranslated: "	log n., v. 	", czWord: "	log    	" },
  { wordTranslated: "	logic n. 	", czWord: "	logika   	" },
  { wordTranslated: "	long-standing adj. 	", czWord: "	dlouholetý   	" },
  { wordTranslated: "	long-time adj. 	", czWord: "	dlouholetý   	" },
  { wordTranslated: "	loom v. 	", czWord: "	tkalcovský stav   	" },
  { wordTranslated: "	loop n. 	", czWord: "	smyčka   	" },
  { wordTranslated: "	loyalty n. 	", czWord: "	věrnost   	" },
  { wordTranslated: "	machinery n. 	", czWord: "	stroje   	" },
  { wordTranslated: "	magical adj. 	", czWord: "	kouzelný   	" },
  { wordTranslated: "	magistrate n. 	", czWord: "	rychtář   	" },
  { wordTranslated: "	magnetic adj. 	", czWord: "	magnetický   	" },
  { wordTranslated: "	magnitude n. 	", czWord: "	velikost   	" },
  { wordTranslated: "	mainland n. 	", czWord: "	pevnina   	" },
  { wordTranslated: "	mainstream n., adj. 	", czWord: "	hlavní proud   	" },
  { wordTranslated: "	maintenance n. 	", czWord: "	údržba   	" },
  { wordTranslated: "	mandate n. 	", czWord: "	mandát   	" },
  { wordTranslated: "	mandatory adj. 	", czWord: "	povinný   	" },
  { wordTranslated: "	manifest v. 	", czWord: "	zjevný   	" },
  { wordTranslated: "	manipulate v. 	", czWord: "	manipulovat   	" },
  { wordTranslated: "	manipulation n. 	", czWord: "	manipulace   	" },
  { wordTranslated: "	manuscript n. 	", czWord: "	rukopis   	" },
  { wordTranslated: "	march n., v. 	", czWord: "	březen   	" },
  { wordTranslated: "	marginal adj. 	", czWord: "	okrajový   	" },
  { wordTranslated: "	marine adj. 	", czWord: "	námořní   	" },
  { wordTranslated: "	marketplace n. 	", czWord: "	tržiště   	" },
  { wordTranslated: "	mask n. 	", czWord: "	maska ​​  	" },
  { wordTranslated: "	massacre n. 	", czWord: "	masakr   	" },
  { wordTranslated: "	mathematical adj. 	", czWord: "	matematický   	" },
  { wordTranslated: "	mature adj., v. 	", czWord: "	zralý    	" },
  { wordTranslated: "	maximize v. 	", czWord: "	maximalizovat   	" },
  { wordTranslated: "	meaningful adj. 	", czWord: "	smysluplný   	" },
  { wordTranslated: "	meantime n. 	", czWord: "	mezitím   	" },
  { wordTranslated: "	medieval adj. 	", czWord: "	středověký   	" },
  { wordTranslated: "	meditation n. 	", czWord: "	meditace   	" },
  { wordTranslated: "	melody n. 	", czWord: "	melodie   	" },
  { wordTranslated: "	memo n. 	", czWord: "	memorandum   	" },
  { wordTranslated: "	memoir n. 	", czWord: "	memoár   	" },
  { wordTranslated: "	memorial n. 	", czWord: "	památník   	" },
  { wordTranslated: "	mentor n. 	", czWord: "	mentor   	" },
  { wordTranslated: "	merchant n. 	", czWord: "	obchodník   	" },
  { wordTranslated: "	mercy n. 	", czWord: "	milosrdenství   	" },
  { wordTranslated: "	mere adj. 	", czWord: "	pouhý   	" },
  { wordTranslated: "	merely adv. 	", czWord: "	pouze ad  	" },
  { wordTranslated: "	merge v. 	", czWord: "	sloučit   	" },
  { wordTranslated: "	merger n. 	", czWord: "	sloučení   	" },
  { wordTranslated: "	merit n. 	", czWord: "	zásluhy   	" },
  { wordTranslated: "	methodology n. 	", czWord: "	metodika   	" },
  { wordTranslated: "	midst n. 	", czWord: "	uprostřed   	" },
  { wordTranslated: "	migration n. 	", czWord: "	migrace   	" },
  { wordTranslated: "	militant n., adj. 	", czWord: "	militantní    	" },
  { wordTranslated: "	militia n. 	", czWord: "	milice   	" },
  { wordTranslated: "	mill n. 	", czWord: "	mlýn   	" },
  { wordTranslated: "	minimal adj. 	", czWord: "	minimální   	" },
  { wordTranslated: "	minimize v. 	", czWord: "	minimalizovat   	" },
  { wordTranslated: "	mining n. 	", czWord: "	těžba   	" },
  { wordTranslated: "	ministry n. 	", czWord: "	ministerstvo   	" },
  { wordTranslated: "	minute 	", czWord: "	minuta 	" },
  { wordTranslated: "	2 adj. 	", czWord: "	2 	" },
  { wordTranslated: "	miracle n. 	", czWord: "	zázrak   	" },
  { wordTranslated: "	misery n. 	", czWord: "	bída   	" },
  { wordTranslated: "	misleading adj. 	", czWord: "	zavádějící   	" },
  { wordTranslated: "	missile n. 	", czWord: "	střela   	" },
  { wordTranslated: "	mob n. 	", czWord: "	dav   	" },
  { wordTranslated: "	mobility n. 	", czWord: "	pohyblivost   	" },
  { wordTranslated: "	mobilize v. 	", czWord: "	mobilizovat   	" },
  { wordTranslated: "	moderate adj. 	", czWord: "	mírný   	" },
  { wordTranslated: "	modification n. 	", czWord: "	modifikace   	" },
  { wordTranslated: "	momentum n. 	", czWord: "	hybnost   	" },
  { wordTranslated: "	monk n. 	", czWord: "	mnich   	" },
  { wordTranslated: "	monopoly n. 	", czWord: "	monopol   	" },
  { wordTranslated: "	morality n. 	", czWord: "	morálka   	" },
  { wordTranslated: "	motive n. 	", czWord: "	motiv   	" },
  { wordTranslated: "	motorist n. 	", czWord: "	motorista   	" },
  { wordTranslated: "	municipal adj. 	", czWord: "	obecní   	" },
  { wordTranslated: "	mutual adj. 	", czWord: "	vzájemný   	" },
  { wordTranslated: "	namely adv. 	", czWord: "	totiž ad  	" },
  { wordTranslated: "	nationwide adj. 	", czWord: "	celostátní   	" },
  { wordTranslated: "	naval adj. 	", czWord: "	námořní   	" },
  { wordTranslated: "	neglect v., n. 	", czWord: "	zanedbat    	" },
  { wordTranslated: "	neighbouring adj. 	", czWord: "	sousední   	" },
  { wordTranslated: "	nest n. 	", czWord: "	hnízdo   	" },
  { wordTranslated: "	net adj. 	", czWord: "	čistý   	" },
  { wordTranslated: "	newsletter n. 	", czWord: "	zpravodaj   	" },
  { wordTranslated: "	niche n. 	", czWord: "	výklenek   	" },
  { wordTranslated: "	noble adj. 	", czWord: "	vznešený   	" },
  { wordTranslated: "	nod v. 	", czWord: "	kývnout   	" },
  { wordTranslated: "	nominate v. 	", czWord: "	nominovat   	" },
  { wordTranslated: "	nomination n. 	", czWord: "	nominace   	" },
  { wordTranslated: "	nominee n. 	", czWord: "	kandidát   	" },
  { wordTranslated: "	nonetheless adv. 	", czWord: "	nicméně  	" },
  { wordTranslated: "	non-profit adj. 	", czWord: "	neziskový   	" },
  { wordTranslated: "	nonsense n. 	", czWord: "	nesmysl   	" },
  { wordTranslated: "	noon n. 	", czWord: "	poledne   	" },
  { wordTranslated: "	notable adj. 	", czWord: "	pozoruhodný   	" },
  { wordTranslated: "	notably adv. 	", czWord: "	zejména  	" },
  { wordTranslated: "	notify v. 	", czWord: "	oznámit   	" },
  { wordTranslated: "	notorious adj. 	", czWord: "	notoricky známý   	" },
  { wordTranslated: "	novel adj. 	", czWord: "	románový   	" },
  { wordTranslated: "	nursery n. 	", czWord: "	školka   	" },
  { wordTranslated: "	objection n. 	", czWord: "	námitka   	" },
  { wordTranslated: "	oblige v. 	", czWord: "	zavázat   	" },
  { wordTranslated: "	obsess v. 	", czWord: "	posedlý   	" },
  { wordTranslated: "	obsession n. 	", czWord: "	posedlost   	" },
  { wordTranslated: "	occasional adj. 	", czWord: "	občasný   	" },
  { wordTranslated: "	occurrence n. 	", czWord: "	výskyt   	" },
  { wordTranslated: "	odds n. 	", czWord: "	kurz   	" },
  { wordTranslated: "	offering n. 	", czWord: "	nabídka   	" },
  { wordTranslated: "	offspring n. 	", czWord: "	potomek   	" },
  { wordTranslated: "	operational adj. 	", czWord: "	provozní   	" },
  { wordTranslated: "	opt v. 	", czWord: "	opt   	" },
  { wordTranslated: "	optical adj. 	", czWord: "	optický   	" },
  { wordTranslated: "	optimism n. 	", czWord: "	optimismus   	" },
  { wordTranslated: "	oral adj. 	", czWord: "	ústní   	" },
  { wordTranslated: "	organizational adj. 	", czWord: "	organizační   	" },
  { wordTranslated: "	orientation n. 	", czWord: "	orientace   	" },
  { wordTranslated: "	originate v. 	", czWord: "	původ   	" },
  { wordTranslated: "	outbreak n. 	", czWord: "	ohnisko   	" },
  { wordTranslated: "	outing n. 	", czWord: "	výlet   	" },
  { wordTranslated: "	outlet n. 	", czWord: "	vývod   	" },
  { wordTranslated: "	outlook n. 	", czWord: "	výhled   	" },
  { wordTranslated: "	outrage n., v. 	", czWord: "	pobouření  	" },
  { wordTranslated: "	outsider n. 	", czWord: "	outsider   	" },
  { wordTranslated: "	overlook v. 	", czWord: "	přehlédnout   	" },
  { wordTranslated: "	overly adv. 	", czWord: "	přehnaně  	" },
  { wordTranslated: "	oversee v. 	", czWord: "	dohlížet   	" },
  { wordTranslated: "	overturn v. 	", czWord: "	převrátit   	" },
  { wordTranslated: "	overwhelm v. 	", czWord: "	přemoci   	" },
  { wordTranslated: "	overwhelming adj. 	", czWord: "	ohromující   	" },
  { wordTranslated: "	pad n. 	", czWord: "	podložka   	" },
  { wordTranslated: "	parameter n. 	", czWord: "	parametr   	" },
  { wordTranslated: "	parental adj. 	", czWord: "	rodičovský   	" },
  { wordTranslated: "	parish n. 	", czWord: "	farnost   	" },
  { wordTranslated: "	parliamentary adj. 	", czWord: "	parlamentní   	" },
  { wordTranslated: "	partial adj. 	", czWord: "	částečný   	" },
  { wordTranslated: "	partially adv. 	", czWord: "	částečně  	" },
  { wordTranslated: "	passing n. 	", czWord: "	míjení   	" },
  { wordTranslated: "	passive adj. 	", czWord: "	pasivní   	" },
  { wordTranslated: "	pastor n. 	", czWord: "	farář   	" },
  { wordTranslated: "	patch n. 	", czWord: "	náplast   	" },
  { wordTranslated: "	patent n. 	", czWord: "	patent   	" },
  { wordTranslated: "	pathway n. 	", czWord: "	cesta   	" },
  { wordTranslated: "	patrol n., v. 	", czWord: "	hlídka   	" },
  { wordTranslated: "	patron n. 	", czWord: "	patron   	" },
  { wordTranslated: "	peak n. 	", czWord: "	vrchol   	" },
  { wordTranslated: "	peasant n. 	", czWord: "	rolník   	" },
  { wordTranslated: "	peculiar adj. 	", czWord: "	zvláštní   	" },
  { wordTranslated: "	persist v. 	", czWord: "	trvat   	" },
  { wordTranslated: "	persistent adj. 	", czWord: "	vytrvalý   	" },
  { wordTranslated: "	personnel n. 	", czWord: "	personál   	" },
  { wordTranslated: "	petition n. 	", czWord: "	petice   	" },
  { wordTranslated: "	philosopher n. 	", czWord: "	filozof   	" },
  { wordTranslated: "	philosophical adj. 	", czWord: "	filozofický   	" },
  { wordTranslated: "	physician n. 	", czWord: "	lékař   	" },
  { wordTranslated: "	pioneer n., v. 	", czWord: "	průkopník    	" },
  { wordTranslated: "	pipeline n. 	", czWord: "	potrubí   	" },
  { wordTranslated: "	pirate n. 	", czWord: "	pirát   	" },
  { wordTranslated: "	pit n. 	", czWord: "	jáma   	" },
  { wordTranslated: "	plea n. 	", czWord: "	prosba   	" },
  { wordTranslated: "	plead v. 	", czWord: "	prosit   	" },
  { wordTranslated: "	pledge v., n. 	", czWord: "	zástava     	" },
  { wordTranslated: "	plug v., n. 	", czWord: "	zástrčka     	" },
  { wordTranslated: "	plunge v. 	", czWord: "	ponořit se   	" },
  { wordTranslated: "	pole n. 	", czWord: "	pól   	" },
  { wordTranslated: "	poll n. 	", czWord: "	anketa   	" },
  { wordTranslated: "	pond n. 	", czWord: "	rybník   	" },
  { wordTranslated: "	pop v. 	", czWord: "	pop   	" },
  { wordTranslated: "	portfolio n. 	", czWord: "	portfolio   	" },
  { wordTranslated: "	portray v. 	", czWord: "	vylíčit   	" },
  { wordTranslated: "	postpone v. 	", czWord: "	odložit   	" },
  { wordTranslated: "	post-war adj. 	", czWord: "	poválečný   	" },
  { wordTranslated: "	practitioner n. 	", czWord: "	praktik   	" },
  { wordTranslated: "	preach v. 	", czWord: "	kázat   	" },
  { wordTranslated: "	precedent n. 	", czWord: "	precedens   	" },
  { wordTranslated: "	precision n. 	", czWord: "	přesnost   	" },
  { wordTranslated: "	predator n. 	", czWord: "	dravec   	" },
  { wordTranslated: "	predecessor n. 	", czWord: "	předchůdce   	" },
  { wordTranslated: "	predominantly adv. 	", czWord: "	převážně  	" },
  { wordTranslated: "	pregnancy n. 	", czWord: "	těhotenství   	" },
  { wordTranslated: "	prejudice n. 	", czWord: "	předsudek   	" },
  { wordTranslated: "	preliminary adj. 	", czWord: "	předběžný   	" },
  { wordTranslated: "	premier n. 	", czWord: "	premiér   	" },
  { wordTranslated: "	premise n. 	", czWord: "	předpoklad   	" },
  { wordTranslated: "	premium n. 	", czWord: "	prémie   	" },
  { wordTranslated: "	prescribe v. 	", czWord: "	předepsat   	" },
  { wordTranslated: "	prescription n. 	", czWord: "	předpis   	" },
  { wordTranslated: "	presently adv. 	", czWord: "	v současnosti   	" },
  { wordTranslated: "	preservation n. 	", czWord: "	konzervace   	" },
  { wordTranslated: "	preside v. 	", czWord: "	předsedat   	" },
  { wordTranslated: "	presidency n. 	", czWord: "	předsednictvo   	" },
  { wordTranslated: "	presidential adj. 	", czWord: "	prezidentský   	" },
  { wordTranslated: "	prestigious adj. 	", czWord: "	prestižní   	" },
  { wordTranslated: "	presumably adv. 	", czWord: "	pravděpodobně   	" },
  { wordTranslated: "	presume v. 	", czWord: "	předpokládat   	" },
  { wordTranslated: "	prevail v. 	", czWord: "	převládnout   	" },
  { wordTranslated: "	prevalence n. 	", czWord: "	prevalence   	" },
  { wordTranslated: "	prevention n. 	", czWord: "	prevence   	" },
  { wordTranslated: "	prey n. 	", czWord: "	kořist   	" },
  { wordTranslated: "	principal n. 	", czWord: "	hlavní   	" },
  { wordTranslated: "	privatization n. 	", czWord: "	privatizace   	" },
  { wordTranslated: "	privilege n. 	", czWord: "	privilegium   	" },
  { wordTranslated: "	probe n., v. 	", czWord: "	sonda     	" },
  { wordTranslated: "	problematic adj. 	", czWord: "	problematický   	" },
  { wordTranslated: "	proceedings n. 	", czWord: "	řízení   	" },
  { wordTranslated: "	proceeds n. 	", czWord: "	výtěžek   	" },
  { wordTranslated: "	processing n. 	", czWord: "	zpracování   	" },
  { wordTranslated: "	processor n. 	", czWord: "	procesor   	" },
  { wordTranslated: "	proclaim v. 	", czWord: "	prohlásit   	" },
  { wordTranslated: "	productive adj. 	", czWord: "	produktivní   	" },
  { wordTranslated: "	productivity n. 	", czWord: "	produktivita   	" },
  { wordTranslated: "	profitable adj. 	", czWord: "	výnosný   	" },
  { wordTranslated: "	profound adj. 	", czWord: "	hluboký   	" },
  { wordTranslated: "	projection n. 	", czWord: "	projekce   	" },
  { wordTranslated: "	prominent adj. 	", czWord: "	prominentní   	" },
  { wordTranslated: "	pronounced adj. 	", czWord: "	vyslovený   	" },
  { wordTranslated: "	propaganda n. 	", czWord: "	propaganda   	" },
  { wordTranslated: "	proposition n. 	", czWord: "	návrh   	" },
  { wordTranslated: "	prosecute v. 	", czWord: "	stíhat   	" },
  { wordTranslated: "	prosecution n. 	", czWord: "	stíhání   	" },
  { wordTranslated: "	prosecutor n. 	", czWord: "	státní zástupce   	" },
  { wordTranslated: "	prospective adj. 	", czWord: "	výhledový   	" },
  { wordTranslated: "	prosperity n. 	", czWord: "	prosperita   	" },
  { wordTranslated: "	protective adj. 	", czWord: "	ochranný   	" },
  { wordTranslated: "	protocol n. 	", czWord: "	protokol   	" },
  { wordTranslated: "	province n. 	", czWord: "	provincie   	" },
  { wordTranslated: "	provincial adj. 	", czWord: "	zemský   	" },
  { wordTranslated: "	provision n. 	", czWord: "	ustanovení   	" },
  { wordTranslated: "	provoke v. 	", czWord: "	provokovat   	" },
  { wordTranslated: "	psychiatric adj. 	", czWord: "	psychiatrický   	" },
  { wordTranslated: "	pulse n. 	", czWord: "	puls   	" },
  { wordTranslated: "	pump v., n. 	", czWord: "	čerpadlo    	" },
  { wordTranslated: "	punch n., v. 	", czWord: "	úder   	" },
  { wordTranslated: "	query n. 	", czWord: "	dotaz   	" },
  { wordTranslated: "	quest n. 	", czWord: "	pátrání   	" },
  { wordTranslated: "	quota n. 	", czWord: "	kvóta   	" },
  { wordTranslated: "	radar n. 	", czWord: "	radar   	" },
  { wordTranslated: "	radical adj. 	", czWord: "	radikální   	" },
  { wordTranslated: "	rage n. 	", czWord: "	vztek   	" },
  { wordTranslated: "	raid n., v. 	", czWord: "	nájezd     	" },
  { wordTranslated: "	rally n., v. 	", czWord: "	rally     	" },
  { wordTranslated: "	ranking n. 	", czWord: "	pořadí   	" },
  { wordTranslated: "	rape n., v. 	", czWord: "	znásilnění    	" },
  { wordTranslated: "	ratio n. 	", czWord: "	poměr   	" },
  { wordTranslated: "	rational adj. 	", czWord: "	rozumný   	" },
  { wordTranslated: "	ray n. 	", czWord: "	paprsek   	" },
  { wordTranslated: "	readily adv. 	", czWord: "	snadno  	" },
  { wordTranslated: "	realization n. 	", czWord: "	realizace   	" },
  { wordTranslated: "	realm n. 	", czWord: "	říše   	" },
  { wordTranslated: "	rear adj., n. 	", czWord: "	zadní     	" },
  { wordTranslated: "	reasoning n. 	", czWord: "	úvaha   	" },
  { wordTranslated: "	reassure v. 	", czWord: "	uklidnit   	" },
  { wordTranslated: "	rebel n. 	", czWord: "	rebel   	" },
  { wordTranslated: "	rebellion n. 	", czWord: "	povstání   	" },
  { wordTranslated: "	recipient n. 	", czWord: "	příjemce   	" },
  { wordTranslated: "	reconstruction n. 	", czWord: "	rekonstrukce   	" },
  { wordTranslated: "	recount1 v. 	", czWord: "	vyprávění   	" },
  { wordTranslated: "	referendum n. 	", czWord: "	referendum   	" },
  { wordTranslated: "	reflection n. 	", czWord: "	odraz   	" },
  { wordTranslated: "	reform n., v. 	", czWord: "	reforma     	" },
  { wordTranslated: "	refuge n. 	", czWord: "	útočiště   	" },
  { wordTranslated: "	refusal n. 	", czWord: "	odmítnutí   	" },
  { wordTranslated: "	regain v. 	", czWord: "	získat zpět   	" },
  { wordTranslated: "	regardless adv. 	", czWord: "	bez ohledu na  	" },
  { wordTranslated: "	regime n. 	", czWord: "	režim   	" },
  { wordTranslated: "	regulator n. 	", czWord: "	regulátor   	" },
  { wordTranslated: "	regulatory adj. 	", czWord: "	regulační   	" },
  { wordTranslated: "	rehabilitation n. 	", czWord: "	rehabilitace   	" },
  { wordTranslated: "	reign n., v. 	", czWord: "	panovat    	" },
  { wordTranslated: "	rejection n. 	", czWord: "	odmítnutí  	" },
  { wordTranslated: "	relevance n. 	", czWord: "	relevance   	" },
  { wordTranslated: "	reliability n. 	", czWord: "	spolehlivost   	" },
  { wordTranslated: "	reluctant adj. 	", czWord: "	zdráhavý   	" },
  { wordTranslated: "	remainder n. 	", czWord: "	zbytek   	" },
  { wordTranslated: "	remains n. 	", czWord: "	zůstává   	" },
  { wordTranslated: "	remedy n. 	", czWord: "	náprava   	" },
  { wordTranslated: "	reminder n. 	", czWord: "	upomínka   	" },
  { wordTranslated: "	removal n. 	", czWord: "	odstranění   	" },
  { wordTranslated: "	render v. 	", czWord: "	render   	" },
  { wordTranslated: "	renew v. 	", czWord: "	obnovit   	" },
  { wordTranslated: "	renowned adj. 	", czWord: "	proslulý   	" },
  { wordTranslated: "	rental n. 	", czWord: "	pronájem   	" },
  { wordTranslated: "	replacement n. 	", czWord: "	výměna   	" },
  { wordTranslated: "	reportedly adv. 	", czWord: "	údajně  	" },
  { wordTranslated: "	representation n. 	", czWord: "	reprezentace   	" },
  { wordTranslated: "	reproduce v. 	", czWord: "	reprodukovat   	" },
  { wordTranslated: "	reproduction n. 	", czWord: "	reprodukce   	" },
  { wordTranslated: "	republic n. 	", czWord: "	republika   	" },
  { wordTranslated: "	resemble v. 	", czWord: "	podobat se   	" },
  { wordTranslated: "	reside v. 	", czWord: "	bydlet   	" },
  { wordTranslated: "	residence n. 	", czWord: "	bydliště   	" },
  { wordTranslated: "	residential adj. 	", czWord: "	obytný   	" },
  { wordTranslated: "	residue n. 	", czWord: "	zbytek   	" },
  { wordTranslated: "	resignation n. 	", czWord: "	rezignace   	" },
  { wordTranslated: "	resistance n. 	", czWord: "	odpor   	" },
  { wordTranslated: "	respective adj. 	", czWord: "	příslušný   	" },
  { wordTranslated: "	respectively adv. 	", czWord: "	respektive ad  	" },
  { wordTranslated: "	restoration n. 	", czWord: "	restaurování   	" },
  { wordTranslated: "	restraint n. 	", czWord: "	omezení   	" },
  { wordTranslated: "	resume v. 	", czWord: "	životopis   	" },
  { wordTranslated: "	retreat n., v. 	", czWord: "	ústup     	" },
  { wordTranslated: "	retrieve v. 	", czWord: "	získat   	" },
  { wordTranslated: "	revelation n. 	", czWord: "	zjevení   	" },
  { wordTranslated: "	revenge n. 	", czWord: "	pomsta   	" },
  { wordTranslated: "	reverse v. , n., adj. 	", czWord: "	obrace     	" },
  { wordTranslated: "	revival n. 	", czWord: "	oživení   	" },
  { wordTranslated: "	revive v. 	", czWord: "	oživit   	" },
  { wordTranslated: "	revolutionary adj. 	", czWord: "	revoluční   	" },
  { wordTranslated: "	rhetoric n. 	", czWord: "	rétorika   	" },
  { wordTranslated: "	rifle n. 	", czWord: "	puška   	" },
  { wordTranslated: "	riot n. 	", czWord: "	vzpoura   	" },
  { wordTranslated: "	rip v. 	", czWord: "	roztrhnout   	" },
  { wordTranslated: "	ritual n. 	", czWord: "	rituál   	" },
  { wordTranslated: "	robust adj. 	", czWord: "	robustní   	" },
  { wordTranslated: "	rock v. 	", czWord: "	rock   	" },
  { wordTranslated: "	rod n. 	", czWord: "	tyč   	" },
  { wordTranslated: "	rotate v. 	", czWord: "	otočit   	" },
  { wordTranslated: "	rotation n. 	", czWord: "	rotace   	" },
  { wordTranslated: "	ruling n. 	", czWord: "	vládnoucí   	" },
  { wordTranslated: "	rumour n. 	", czWord: "	pověst   	" },
  { wordTranslated: "	sack v. 	", czWord: "	pytel   	" },
  { wordTranslated: "	sacred adj. 	", czWord: "	posvátný   	" },
  { wordTranslated: "	sacrifice n., v. 	", czWord: "	obětovat   	" },
  { wordTranslated: "	saint n. 	", czWord: "	svatý   	" },
  { wordTranslated: "	sake n. 	", czWord: "	sake   	" },
  { wordTranslated: "	sanction n. 	", czWord: "	sankce   	" },
  { wordTranslated: "	say n. 	", czWord: "	řekni   	" },
  { wordTranslated: "	scattered adj. 	", czWord: "	rozptýlený   	" },
  { wordTranslated: "	sceptical adj. 	", czWord: "	skeptický   	" },
  { wordTranslated: "	scope n. 	", czWord: "	rozsah   	" },
  { wordTranslated: "	screw v., n. 	", czWord: "	šroub    	" },
  { wordTranslated: "	scrutiny n. 	", czWord: "	kontrola   	" },
  { wordTranslated: "	seal v., n. 	", czWord: "	pečeť    	" },
  { wordTranslated: "	secular adj. 	", czWord: "	světský   	" },
  { wordTranslated: "	seemingly adv. 	", czWord: "	zdánlivě   	" },
  { wordTranslated: "	segment n. 	", czWord: "	segment   	" },
  { wordTranslated: "	seize v. 	", czWord: "	chytit   	" },
  { wordTranslated: "	seldom adv. 	", czWord: "	zřídka  	" },
  { wordTranslated: "	selective adj. 	", czWord: "	selektivní   	" },
  { wordTranslated: "	senator n. 	", czWord: "	senátor   	" },
  { wordTranslated: "	sensation n. 	", czWord: "	pocit   	" },
  { wordTranslated: "	sensitivity n. 	", czWord: "	citlivost   	" },
  { wordTranslated: "	sentiment n. 	", czWord: "	sentiment   	" },
  { wordTranslated: "	separation n. 	", czWord: "	oddělení   	" },
  { wordTranslated: "	serial adj. 	", czWord: "	řadový   	" },
  { wordTranslated: "	settlement n. 	", czWord: "	osada   	" },
  { wordTranslated: "	set-up n. 	", czWord: "	nastavení   	" },
  { wordTranslated: "	sexuality n. 	", czWord: "	sexualita   	" },
  { wordTranslated: "	shareholder n. 	", czWord: "	akcionář   	" },
  { wordTranslated: "	shatter v. 	", czWord: "	rozbít   	" },
  { wordTranslated: "	shed v. 	", czWord: "	bouda   	" },
  { wordTranslated: "	sheer adj. 	", czWord: "	čirý   	" },
  { wordTranslated: "	shipping n. 	", czWord: "	doprava   	" },
  { wordTranslated: "	shoot n. 	", czWord: "	střílet   	" },
  { wordTranslated: "	shrink v. 	", czWord: "	zmenšit   	" },
  { wordTranslated: "	shrug v. 	", czWord: "	pokrčit rameny   	" },
  { wordTranslated: "	sigh v., n. 	", czWord: "	povzdech     	" },
  { wordTranslated: "	simulate v. 	", czWord: "	simulovat   	" },
  { wordTranslated: "	simulation n. 	", czWord: "	simulace   	" },
  { wordTranslated: "	simultaneously adv. 	", czWord: "	současně   	" },
  { wordTranslated: "	sin n. 	", czWord: "	hřích   	" },
  { wordTranslated: "	situated adj. 	", czWord: "	umístěný   	" },
  { wordTranslated: "	sketch n. 	", czWord: "	skica   	" },
  { wordTranslated: "	skip v. 	", czWord: "	přeskočit   	" },
  { wordTranslated: "	slam v. 	", czWord: "	bouchnout   	" },
  { wordTranslated: "	slap v. 	", czWord: "	facka   	" },
  { wordTranslated: "	slash v. 	", czWord: "	lomítko   	" },
  { wordTranslated: "	slavery n. 	", czWord: "	otroctví   	" },
  { wordTranslated: "	slot n. 	", czWord: "	slot   	" },
  { wordTranslated: "	smash v. 	", czWord: "	rozbít   	" },
  { wordTranslated: "	snap v. 	", czWord: "	snap   	" },
  { wordTranslated: "	soak v. 	", czWord: "	namočit   	" },
  { wordTranslated: "	soar v. 	", czWord: "	stoupat   	" },
  { wordTranslated: "	socialist adj. 	", czWord: "	socialistický   	" },
  { wordTranslated: "	sole adj. 	", czWord: "	jediný   	" },
  { wordTranslated: "	solely adv. 	", czWord: "	pouze  	" },
  { wordTranslated: "	solicitor n. 	", czWord: "	advokát   	" },
  { wordTranslated: "	solidarity n. 	", czWord: "	solidarita   	" },
  { wordTranslated: "	solo adj., n. 	", czWord: "	sólo     	" },
  { wordTranslated: "	sound adj. 	", czWord: "	zvuk   	" },
  { wordTranslated: "	sovereignty n. 	", czWord: "	suverenita   	" },
  { wordTranslated: "	spam n. 	", czWord: "	spam   	" },
  { wordTranslated: "	span v., n. 	", czWord: "	rozpětí    	" },
  { wordTranslated: "	spare v. 	", czWord: "	náhradní   	" },
  { wordTranslated: "	spark v. 	", czWord: "	jiskra   	" },
  { wordTranslated: "	specialized adj. 	", czWord: "	specializovaný   	" },
  { wordTranslated: "	specification n. 	", czWord: "	specifikace   	" },
  { wordTranslated: "	specimen n. 	", czWord: "	exemplář   	" },
  { wordTranslated: "	spectacle n. 	", czWord: "	podívaná   	" },
  { wordTranslated: "	spectrum n. 	", czWord: "	spektrum   	" },
  { wordTranslated: "	spell n. 	", czWord: "	kouzlo   	" },
  { wordTranslated: "	sphere n. 	", czWord: "	koule   	" },
  { wordTranslated: "	spin v., n. 	", czWord: "	spin    	" },
  { wordTranslated: "	spine n. 	", czWord: "	páteř   	" },
  { wordTranslated: "	spotlight n. 	", czWord: "	reflektor   	" },
  { wordTranslated: "	spouse n. 	", czWord: "	manžel   	" },
  { wordTranslated: "	spy n., v. 	", czWord: "	špion    	" },
  { wordTranslated: "	squad n. 	", czWord: "	četa   	" },
  { wordTranslated: "	squeeze v. 	", czWord: "	zmáčknout   	" },
  { wordTranslated: "	stab v. 	", czWord: "	bodnout   	" },
  { wordTranslated: "	stability n. 	", czWord: "	stabilita   	" },
  { wordTranslated: "	stabilize v. 	", czWord: "	stabilizovat   	" },
  { wordTranslated: "	stake n. 	", czWord: "	kůl   	" },
  { wordTranslated: "	standing adj. 	", czWord: "	stojící   	" },
  { wordTranslated: "	stark adj. 	", czWord: "	ostrý   	" },
  { wordTranslated: "	statistical adj. 	", czWord: "	statistický   	" },
  { wordTranslated: "	steer v. 	", czWord: "	řídit   	" },
  { wordTranslated: "	stem n., v. 	", czWord: "	kmen    	" },
  { wordTranslated: "	stereotype n. 	", czWord: "	stereotyp   	" },
  { wordTranslated: "	stimulus n. 	", czWord: "	podnět   	" },
  { wordTranslated: "	stir v. 	", czWord: "	míchat   	" },
  { wordTranslated: "	storage n. 	", czWord: "	sklad   	" },
  { wordTranslated: "	straightforward adj. 	", czWord: "	přímočarý   	" },
  { wordTranslated: "	strain n. 	", czWord: "	kmen   	" },
  { wordTranslated: "	strand n. 	", czWord: "	pramen   	" },
  { wordTranslated: "	strategic adj. 	", czWord: "	strategický   	" },
  { wordTranslated: "	striking adj. 	", czWord: "	úderný   	" },
  {
    wordTranslated: "	strip (long narrow piece) n. 	",
    czWord: "	proužek (dlouhý úzký kus)   	",
  },
  {
    wordTranslated: "	strip (remove clothes/a layer) v. 	",
    czWord: "	svléknout (sejmout oblečení/vrstvu)   	",
  },
  { wordTranslated: "	strive v. 	", czWord: "	snažit se   	" },
  { wordTranslated: "	structural adj. 	", czWord: "	strukturální   	" },
  { wordTranslated: "	stumble v. 	", czWord: "	klopýtnout   	" },
  { wordTranslated: "	stun v. 	", czWord: "	omráčit   	" },
  { wordTranslated: "	submission n. 	", czWord: "	podání   	" },
  { wordTranslated: "	subscriber n. 	", czWord: "	předplatitel   	" },
  { wordTranslated: "	subscription n. 	", czWord: "	předplatné   	" },
  { wordTranslated: "	subsidy n. 	", czWord: "	dotace   	" },
  { wordTranslated: "	substantial adj. 	", czWord: "	podstatný   	" },
  { wordTranslated: "	substantially adv. 	", czWord: "	podstatně ad  	" },
  { wordTranslated: "	substitute n., v. 	", czWord: "	náhradní     	" },
  { wordTranslated: "	substitution n. 	", czWord: "	substituce   	" },
  { wordTranslated: "	subtle adj. 	", czWord: "	jemný   	" },
  { wordTranslated: "	suburban adj. 	", czWord: "	předměstský   	" },
  { wordTranslated: "	succession n. 	", czWord: "	posloupnost   	" },
  { wordTranslated: "	successive adj. 	", czWord: "	postupný   	" },
  { wordTranslated: "	successor n. 	", czWord: "	nástupce   	" },
  { wordTranslated: "	suck v. 	", czWord: "	sát   	" },
  { wordTranslated: "	sue v. 	", czWord: "	žalovat   	" },
  { wordTranslated: "	suicide n. 	", czWord: "	sebevražda   	" },
  { wordTranslated: "	suite n. 	", czWord: "	apartmá   	" },
  { wordTranslated: "	summit n. 	", czWord: "	vrchol   	" },
  { wordTranslated: "	superb adj. 	", czWord: "	skvělý   	" },
  { wordTranslated: "	superior adj. 	", czWord: "	nadřazený   	" },
  { wordTranslated: "	supervise v. 	", czWord: "	dohlížet   	" },
  { wordTranslated: "	supervision n. 	", czWord: "	dozor   	" },
  { wordTranslated: "	supervisor n. 	", czWord: "	vedoucí   	" },
  { wordTranslated: "	supplement n., v. 	", czWord: "	doplněk     	" },
  { wordTranslated: "	supportive adj. 	", czWord: "	podpůrný   	" },
  { wordTranslated: "	supposedly adv. 	", czWord: "	prý ad  	" },
  { wordTranslated: "	suppress v. 	", czWord: "	potlačit   	" },
  { wordTranslated: "	supreme adj. 	", czWord: "	nejvyšší   	" },
  { wordTranslated: "	surge n., v. 	", czWord: "	přepětí    	" },
  { wordTranslated: "	surgical adj. 	", czWord: "	chirurgický   	" },
  { wordTranslated: "	surplus n. 	", czWord: "	přebytek   	" },
  { wordTranslated: "	surrender v. 	", czWord: "	vzdát se   	" },
  { wordTranslated: "	surveillance n. 	", czWord: "	dohled   	" },
  { wordTranslated: "	suspension n. 	", czWord: "	zavěšení   	" },
  { wordTranslated: "	suspicion n. 	", czWord: "	podezření   	" },
  { wordTranslated: "	suspicious adj. 	", czWord: "	podezřelý   	" },
  { wordTranslated: "	sustain v. 	", czWord: "	udržet   	" },
  { wordTranslated: "	swing v., n. 	", czWord: "	houpačka     	" },
  { wordTranslated: "	sword n. 	", czWord: "	meč   	" },
  { wordTranslated: "	symbolic adj. 	", czWord: "	symbolický   	" },
  { wordTranslated: "	syndrome n. 	", czWord: "	syndrom   	" },
  { wordTranslated: "	synthesis n. 	", czWord: "	syntéza   	" },
  { wordTranslated: "	systematic adj. 	", czWord: "	systematický   	" },
  { wordTranslated: "	tackle n. 	", czWord: "	řešit   	" },
  { wordTranslated: "	tactic n. 	", czWord: "	taktika   	" },
  { wordTranslated: "	tactical adj. 	", czWord: "	taktický   	" },
  { wordTranslated: "	taxpayer n. 	", czWord: "	daňový poplatník   	" },
  { wordTranslated: "	tempt v. 	", czWord: "	pokoušet   	" },
  { wordTranslated: "	tenant n. 	", czWord: "	nájemník   	" },
  { wordTranslated: "	tender adj. 	", czWord: "	něžný   	" },
  { wordTranslated: "	tenure n. 	", czWord: "	funkční období   	" },
  { wordTranslated: "	terminal adj. 	", czWord: "	koncový   	" },
  { wordTranslated: "	terminate v. 	", czWord: "	ukončit   	" },
  { wordTranslated: "	terrain n. 	", czWord: "	terén   	" },
  { wordTranslated: "	terrific adj. 	", czWord: "	skvělý   	" },
  { wordTranslated: "	testify v. 	", czWord: "	svědčit   	" },
  { wordTranslated: "	testimony n. 	", czWord: "	svědectví   	" },
  { wordTranslated: "	texture n. 	", czWord: "	textura   	" },
  { wordTranslated: "	thankfully adv. 	", czWord: "	naštěstí   	" },
  { wordTranslated: "	theatrical adj. 	", czWord: "	divadelní   	" },
  { wordTranslated: "	theology n. 	", czWord: "	teologie   	" },
  { wordTranslated: "	theoretical adj. 	", czWord: "	teoretický   	" },
  { wordTranslated: "	thereafter adv. 	", czWord: "	poté ad  	" },
  { wordTranslated: "	thereby adv. 	", czWord: "	tím ad  	" },
  { wordTranslated: "	thoughtful adj. 	", czWord: "	přemýšlivý   	" },
  { wordTranslated: "	thought-provoking adj. 	", czWord: "	myšlenkový   	" },
  { wordTranslated: "	thread n. 	", czWord: "	závit   	" },
  { wordTranslated: "	threshold n. 	", czWord: "	práh   	" },
  { wordTranslated: "	thrilled adj. 	", czWord: "	nadšený   	" },
  { wordTranslated: "	thrive v. 	", czWord: "	prospívat   	" },
  { wordTranslated: "	tide n. 	", czWord: "	příliv   	" },
  { wordTranslated: "	tighten v. 	", czWord: "	utáhnout   	" },
  { wordTranslated: "	timber n. 	", czWord: "	dřevo   	" },
  { wordTranslated: "	timely adj. 	", czWord: "	včasný   	" },
  { wordTranslated: "	tobacco n. 	", czWord: "	tabák   	" },
  { wordTranslated: "	tolerance n. 	", czWord: "	tolerance   	" },
  { wordTranslated: "	tolerate v. 	", czWord: "	tolerovat   	" },
  { wordTranslated: "	toll n. 	", czWord: "	mýtné   	" },
  { wordTranslated: "	 	", czWord: "	 	" },
  { wordTranslated: "	top v. 	", czWord: "	horní   	" },
  { wordTranslated: "	torture n., v. 	", czWord: "	mučení     	" },
  { wordTranslated: "	toss v. 	", czWord: "	hodit   	" },
  { wordTranslated: "	total v. 	", czWord: "	celkem   	" },
  { wordTranslated: "	toxic adj. 	", czWord: "	jedovatý   	" },
  { wordTranslated: "	trace n. 	", czWord: "	stopa   	" },
  { wordTranslated: "	trademark n. 	", czWord: "	ochranná známka   	" },
  { wordTranslated: "	trail n., v. 	", czWord: "	stezka    	" },
  { wordTranslated: "	trailer n. 	", czWord: "	přívěs   	" },
  { wordTranslated: "	transaction n. 	", czWord: "	transakce   	" },
  { wordTranslated: "	transcript n. 	", czWord: "	přepis   	" },
  { wordTranslated: "	transformation n. 	", czWord: "	transformace   	" },
  { wordTranslated: "	transit n. 	", czWord: "	tranzit   	" },
  { wordTranslated: "	transmission n. 	", czWord: "	přenos   	" },
  { wordTranslated: "	transparency n. 	", czWord: "	průhlednost   	" },
  { wordTranslated: "	transparent adj. 	", czWord: "	průhledný   	" },
  { wordTranslated: "	trauma n. 	", czWord: "	trauma   	" },
  { wordTranslated: "	treaty n. 	", czWord: "	smlouva   	" },
  { wordTranslated: "	tremendous adj. 	", czWord: "	ohromný   	" },
  { wordTranslated: "	tribal adj. 	", czWord: "	kmenový   	" },
  { wordTranslated: "	tribunal n. 	", czWord: "	tribunál   	" },
  { wordTranslated: "	tribute n. 	", czWord: "	hold   	" },
  { wordTranslated: "	trigger n. 	", czWord: "	spoušť   	" },
  { wordTranslated: "	trio n. 	", czWord: "	trio   	" },
  { wordTranslated: "	triumph n. 	", czWord: "	triumf   	" },
  { wordTranslated: "	trophy n. 	", czWord: "	trofej   	" },
  { wordTranslated: "	troubled adj. 	", czWord: "	utrápený   	" },
  { wordTranslated: "	trustee n. 	", czWord: "	správce   	" },
  { wordTranslated: "	tuition n. 	", czWord: "	školné   	" },
  { wordTranslated: "	turnout n. 	", czWord: "	výhybka   	" },
  { wordTranslated: "	turnover n. 	", czWord: "	obrat   	" },
  { wordTranslated: "	twist v., n. 	", czWord: "	kroutit    	" },
  { wordTranslated: "	undergraduate n. 	", czWord: "	vysokoškolák   	" },
  { wordTranslated: "	underlying adj. 	", czWord: "	podkladový   	" },
  { wordTranslated: "	undermine v. 	", czWord: "	podkopat   	" },
  { wordTranslated: "	undoubtedly adv. 	", czWord: "	nepochybně ad  	" },
  { wordTranslated: "	unify v. 	", czWord: "	sjednotit   	" },
  { wordTranslated: "	unprecedented adj. 	", czWord: "	nebývalý   	" },
  { wordTranslated: "	unveil v. 	", czWord: "	odhalit   	" },
  { wordTranslated: "	upcoming adj. 	", czWord: "	nadcházející   	" },
  { wordTranslated: "	upgrade v., n. 	", czWord: "	upgrade    	" },
  { wordTranslated: "	uphold v. 	", czWord: "	podporovat   	" },
  { wordTranslated: "	utility n. 	", czWord: "	užitná   	" },
  { wordTranslated: "	utilize v. 	", czWord: "	využít   	" },
  { wordTranslated: "	utterly adv. 	", czWord: "	zcela ad  	" },
  { wordTranslated: "	vacuum n. 	", czWord: "	vakuum   	" },
  { wordTranslated: "	vague adj. 	", czWord: "	neurčitý   	" },
  { wordTranslated: "	validity n. 	", czWord: "	platnost   	" },
  { wordTranslated: "	vanish v. 	", czWord: "	zmizet   	" },
  { wordTranslated: "	variable n., adj. 	", czWord: "	proměnný   	" },
  { wordTranslated: "	varied adj. 	", czWord: "	rozmanitý   	" },
  { wordTranslated: "	vein n. 	", czWord: "	žíla   	" },
  { wordTranslated: "	venture n., v. 	", czWord: "	podnik   	" },
  { wordTranslated: "	verbal adj. 	", czWord: "	slovesný   	" },
  { wordTranslated: "	verdict n. 	", czWord: "	verdikt   	" },
  { wordTranslated: "	verify v. 	", czWord: "	ověřit   	" },
  { wordTranslated: "	verse n. 	", czWord: "	verš   	" },
  { wordTranslated: "	versus prep. 	", czWord: "	oproti  	" },
  { wordTranslated: "	vessel n. 	", czWord: "	nádoba   	" },
  { wordTranslated: "	veteran n. 	", czWord: "	veterán   	" },
  { wordTranslated: "	viable adj. 	", czWord: "	životaschopný   	" },
  { wordTranslated: "	vibrant adj. 	", czWord: "	vibrující   	" },
  { wordTranslated: "	vice n. 	", czWord: "	vice   	" },
  { wordTranslated: "	vicious adj. 	", czWord: "	zlomyslný   	" },
  { wordTranslated: "	villager n. 	", czWord: "	vesničan   	" },
  { wordTranslated: "	violate v. 	", czWord: "	porušovat   	" },
  { wordTranslated: "	violation n. 	", czWord: "	porušení   	" },
  { wordTranslated: "	virtue n. 	", czWord: "	ctnost   	" },
  { wordTranslated: "	vocal adj. 	", czWord: "	vokální   	" },
  { wordTranslated: "	vow v. 	", czWord: "	slib   	" },
  { wordTranslated: "	vulnerability n. 	", czWord: "	zranitelnost   	" },
  { wordTranslated: "	vulnerable adj. 	", czWord: "	zranitelný   	" },
  { wordTranslated: "	ward n. 	", czWord: "	oddělení   	" },
  { wordTranslated: "	warehouse n. 	", czWord: "	sklad   	" },
  { wordTranslated: "	warfare n. 	", czWord: "	válčení   	" },
  { wordTranslated: "	warrant n., v. 	", czWord: "	příkaz   	" },
  { wordTranslated: "	warrior n. 	", czWord: "	válečník   	" },
  { wordTranslated: "	weaken v. 	", czWord: "	oslabit   	" },
  { wordTranslated: "	weave v. 	", czWord: "	tkát   	" },
  { wordTranslated: "	weed n. 	", czWord: "	plevel   	" },
  { wordTranslated: "	well n. 	", czWord: "	dobře   	" },
  { wordTranslated: "	well-being n. 	", czWord: "	pohoda   	" },
  { wordTranslated: "	whatsoever adv. 	", czWord: "	cokoliv  	" },
  { wordTranslated: "	whereby adv. 	", czWord: "	čímž  	" },
  { wordTranslated: "	whilst conj. 	", czWord: "	zatímco   	" },
  { wordTranslated: "	whip v. 	", czWord: "	bič   	" },
  { wordTranslated: "	wholly adv. 	", czWord: "	zcela   	" },
  { wordTranslated: "	widen v. 	", czWord: "	rozšířit   	" },
  { wordTranslated: "	widow n. 	", czWord: "	vdova   	" },
  { wordTranslated: "	width n. 	", czWord: "	šířka   	" },
  { wordTranslated: "	willingness n. 	", czWord: "	ochota   	" },
  { wordTranslated: "	wipe v. 	", czWord: "	vymazat   	" },
  { wordTranslated: "	wit n. 	", czWord: "	vtip   	" },
  { wordTranslated: "	withdrawal n. 	", czWord: "	stažení   	" },
  { wordTranslated: "	workout n. 	", czWord: "	cvičení   	" },
  { wordTranslated: "	worship n., v. 	", czWord: "	uctívání     	" },
  { wordTranslated: "	worthwhile adj. 	", czWord: "	hodný   	" },
  { wordTranslated: "	worthy adj. 	", czWord: "	hodný   	" },
  { wordTranslated: "	yell v. 	", czWord: "	křičet   	" },
  { wordTranslated: "	yield n., v. 	", czWord: "	výnos     	" },
  { wordTranslated: "	youngster n 	", czWord: "	mladík  	" },
];
